import React, { useEffect, useMemo, useRef, useState } from "react";
import DataTable from "components/Core/DataTable";
import Purchaser from "../../lib/Core/Backend/Controllers/Purchaser";
import PurchaseOrder from "../../lib/Core/Backend/Controllers/PurchaseOrder";
import Brand from "../../lib/Core/Backend/Controllers/Brand";
import CardType from "../../lib/Core/Backend/Controllers/CardType";
import PurchaseOrderProcessing from "lib/Core/Backend/Controllers/PurchaseOrderProcessing";
import Notify from "../../lib/Utils/Alert";
import Spinner from 'react-bootstrap/Spinner';
import Select from "react-select";
import {
  Col,
  Row,
  FormGroup,
  Label,
  ModalFooter,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Button,
  Input,
} from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
// import ReactNotificationAlert from "react-notification-alert";
import NotificationAlert from "react-notification-alert";
import { SwipeableDrawer } from "@mui/material";
import OrderDetails from "components/PurchaseOrder/OrderDetails";
import OrderBatch from "components/PurchaseOrder/OrderBatch";
import useCatalogs from "hooks/useCatalogs";
import ModalUploadCSV from "components/Supplier/ModalUploadCSV";
import * as modalCSVcss from "../../components/Supplier/css/modalUploadCSV.module.css";
import { ReactComponent as UploadIcon } from "../../assets/img/upload.svg";
import okIMG from "../../assets/img/ok.png";
import Pagination from "react-bootstrap/Pagination";
import "../../assets/scss/react/_buttons.scss";
import OrderModifyDetails from "components/PurchaseOrder/OrderModifyDetails";
import OrderNRTModify from "components/PurchaseOrder/OrderNRTModify";

const pageSize = 10;
const TablePagination = ({
  totalItems,
  pageNumber,
  onPageChange,
  indexUpdate,
  pageSizeNew
}) => {
  // Number of pages to display initially
  const [displayedPages, setDisplayedPages] = useState(pageSize);
  const totalPages = Math.ceil(totalItems / pageSizeNew);
  const pageNumbers = Array.from(
    { length: totalPages },
    (_, index) => index + 1
  );

  return (
    <div className="d-flex g-2 ">
      <Pagination>
        <Pagination.Prev
          onClick={() => onPageChange(pageNumber > 1 ? pageNumber - 1 : 1)}
        />
        {indexUpdate > 0
          ? pageNumbers.map((page) => (
              <Pagination.Item
                key={page + indexUpdate}
                active={page === pageNumber}
                onClick={() => onPageChange(page)}
              >
                {page + indexUpdate}
              </Pagination.Item>
            ))
          : pageNumbers.map((page) => (
              <Pagination.Item
                key={page}
                active={page === pageNumber}
                onClick={() => onPageChange(page)}
              >
                {page}
              </Pagination.Item>
            ))}

        <Pagination.Next
          onClick={() =>
            onPageChange(pageNumber < totalItems ? pageNumber + 1 : totalItems)
          }
          disabled={pageNumber === totalPages}
        />
      </Pagination>
      <div className="ms-2"></div>
    </div>
  );
};

const ITEMS_PER_PAGE = 10;
const MAX_VISIBLE_PAGES = 5; // Adjust this number as needed

const CustomPagination = ({ totalItems, currentPage, onPageChange,pageSizeNew }) => {
  const totalPages = Math.ceil(totalItems / pageSizeNew);
  const pageNumbers = Array.from(
    { length: totalPages },
    (_, index) => index + 1
  );

  const renderPageNumbers = () => {
    if (totalPages <= MAX_VISIBLE_PAGES) {
      return pageNumbers.map((page) => (
        <Pagination.Item
          key={page}
          active={page === currentPage}
          onClick={() => onPageChange(page)}
        >
          {page}
        </Pagination.Item>
      ));
    }

    const startPage = Math.max(
      1,
      currentPage - Math.floor(MAX_VISIBLE_PAGES / 2)
    );
    const endPage = Math.min(totalPages, startPage + MAX_VISIBLE_PAGES - 1);

    const pages = [];
    if (startPage > 1) {
      pages.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
    }

    for (let page = startPage; page <= endPage; page++) {
      pages.push(
        <Pagination.Item
          key={page}
          active={page === currentPage}
          onClick={() => onPageChange(page)}
        >
          {page}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      pages.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
    }

    return pages;
  };

  return (
    <Pagination>
      <Pagination.First onClick={() => onPageChange(1)} />
      <Pagination.Prev
        onClick={() => onPageChange(currentPage > 1 ? currentPage - 1 : 1)}
      />

      {renderPageNumbers()}

      <Pagination.Next
        onClick={() =>
          onPageChange(currentPage < totalPages ? currentPage + 1 : totalPages)
        }
        disabled={currentPage === totalPages}
      />
      <Pagination.Last onClick={() => onPageChange(totalPages)} />
    </Pagination>
  );
};

const PurchaseOrdersByPurchaser = (props) => {
  const { token ,accessRoles } = props;
  const { currencies } = useCatalogs();
  const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
  const purchaseOrderCtl = useMemo(() => new PurchaseOrder(token), [token]);
  const brandsCtl = useMemo(() => new Brand(token), [token]);
  const cardTypeCtl = useMemo(() => new CardType(token), [token]);
  const PoProcessingCtl = useMemo(
    () => new PurchaseOrderProcessing(token),
    [token]
  );
  const dollarUSLocale = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openModifyDrawer, setOpenModifyDrawer] = useState(false);
  const [openNRTModifyDrawer,setOpenNRTModifyDrawer] = useState(false)
  const [modalUploadCSV, setModalUploadCSV] = useState(false);
  const [openBatchDrwer, setOpenBatchDrawer] = useState(false);
  const [password,setPassword] = useState(false);
  
  const toggleDrawer = () => setOpenDrawer(!openDrawer);
  const toggleModifyDrawer = () => setOpenModifyDrawer(!openModifyDrawer);
  const toggleModifyNRTDrawer = () => setOpenNRTModifyDrawer(!openNRTModifyDrawer)
  const toogleBatchDrawer = () => setOpenBatchDrawer(!openBatchDrwer);
  const toggleModalCSV = () => setModalUploadCSV(!modalUploadCSV);
  const toggleResetPassword = () => setPassword(!password)
  const [purchasers, setPurchasers] = useState([
    { value: 1, name: "All Orders", label: "All Orders" },
  ]);
  const [orderDetail, setOrderDetail] = useState();
  const [batchDetails, setBatchDetails] = useState();
  const [brands, setBrands] = useState([]);
  const [cardTypes, setCardTypes] = useState([]);
  const [uploadJson, setUploadJson] = useState(null);
  const [downloadId, setDownloadId] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const purchaser = useRef();
  const alert = useRef();
  const table = useRef();
  const [saveCsv, setSaveCsv] = useState(false);
  const [uploadCSV, setUploadCSV] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileCsv, setFileCsv] = useState(null);
  const [selectedFileNew,setSelectedFileNew] = useState(null);
  const [fileCsvNew,setFileCsvNew] = useState(null);
  const [selectedFileTwo,setSelectedFileTwo] = useState(null);
  const [fileCsvTwo,setFileCsvTwo] = useState(null)
  const [rowData, setRowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [retryModal, setRetryModal] = useState(false);
  const [updateTable, setUpdateTable] = useState(true);
  const [orderData, setOrderData] = useState({});
  const [currentData, setCurrentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [inputValue, setInputValue] = useState();
  const [globalSearch, setGlobalSearch] = useState("");
  const [currentList, setCurentList] = useState([]);
  const [purName, setPurName] = useState([]);
  const [purDate, setPurDate] = useState([]);
  const [purOrder, setPurOrder] = useState([]);
  const [orderRef, setOrderRef] = useState([]);
  const [purStatus, setPurStatus] = useState([]);
  const [filterActive, setFilterActive] = useState(false);
  const [size, setSize] = useState(100);
  const [hasNRT, setHasNRT] = useState(false);
  const [releaseOpen, setReleaseOpen] = useState(false);
  const [cancelOdr, setCancelOdr] = useState(false);
  const [downOrder, setDownOrder] = useState(false);
  const [confrimButton, setCofrimButton] = useState(false);
  const [show, setShow] = useState(0);
  const [showTwo,setShowTwo] = useState(0)
  const [showThree,setShwoThree] = useState(0)
  const [purchaserName, setPurchaserName] = useState(null);
  const [checkOrder, setCheckOrder] = useState(null);
  const [warningModal, setWarningModal] = useState(false);
  const [order, setOrder] = useState();
  const [rowDownloadData, setRowDownloadData] = useState();
  const [confrimCsv,setConfirmCsv] = useState(false);
  const [confirmFileCsv,setConfirmFileCsv] = useState(false)
  const [replaceUpload,setReplaceUpload] = useState(false);
  const [confrimCsvTwo,setConfirmCsvTwo] = useState(false);
  const [restoreModal,setRestoreModal] = useState(false);
  const [loader,setLoader] = useState(false);
  const [restoreLoader,setRestoreLoader] = useState(false);
  const [openDrawerId, setOpenDrawerId] = useState(null);
  const [loaderTwo,setLoaderTwo] = useState(false);
  const [nestedData,setNestedData] = useState([]);
  const [pageSizeNew,setPageSizeNew] = useState(10)
  const [showDropdown, setShowDropdown] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10); 
  const [selectShow,setSelectShow] = useState(false)
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedNames,setSelectedNames] = useState([]);
  const [selectedStatus,setSelectedStatus] = useState([]);
  const [isOpenTwo,setIsOpenTwo] = useState(false)
  const [cancelOrderall,setCancelOderAll] = useState(false);
  const [retryAll,setRetryAll] = useState(false)
  const [startDateTwo,setStartDateTwo] = useState('')
  
  ;
  const [endDateTwo,setEndDateTwo] = useState('')
  const [cancelAllLoader,setCancelAllLoader] = useState(false)
  const [confirmAllLoader,setConfirmAllLoader] = useState(false)
  const [dateSearchLoader,setDateSerchLoader] = useState(false)
  const [showApplyButton, setShowApplyButton] = useState(false);
  const [apiIssueModal,setApiIssueModal] = useState(false);
  const [approveModal,setApproveModal] = useState(false);
  const [apidetails, setApiDetails] = useState([
]);
const [showModal, setShowModal] = useState(false);
  const [apiIssueLoader, setApiIssueLoader] = useState(false);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [confirmReport,setConfirmReport] = useState(false)
  const [buttonLoading,setButtonLoading] = useState(false)
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [uploadGetCsv,setUploadGetCsv] = useState(false)
  const [approveFile,setApproveFile] = useState(false);

  const toggleDropdownTwo = () => {
    setShowDropdown(!showDropdown);
  };
  const toggleUpload = () => setUploadCSV(!uploadCSV);
  const toggleRetry = () => setRetryModal(!retryModal);
  const toggleRelease = () => setReleaseOpen(!releaseOpen);
  const toggleCancel = () => setCancelOdr(!cancelOdr);
  const toggleWarning = () => setWarningModal(!warningModal);
  const toggleDownload = () => setDownOrder(!downOrder);
  const toggleConfimCsv = () => setConfirmCsv(!confrimCsv);
  const toggleConfimCsvTwo = () =>setConfirmCsvTwo(!confrimCsvTwo)
  const toggleReplaceUpload = () => setReplaceUpload(!replaceUpload)
  const toggleRestoreOrder = () => setRestoreModal(!restoreModal);
  const toggleCancelAll = () => setCancelOderAll(!cancelOrderall);
  const toggleRetryAll = () => setRetryAll(!retryAll)
  const toggleIssueDeatils = () => setApiIssueModal(!apiIssueModal)
  const toggleApprove = () => setApproveModal(!approveModal);
  const toggleApproveFile = () => setApproveFile(!approveFile);
  const toggleconfirmSalesReport = () => setConfirmReport(!confirmReport)
  const toggleFileUpload = () => setUploadGetCsv(!uploadGetCsv);
  const toggleConfimCsvFile = () => setConfirmFileCsv(!confirmFileCsv)

  const dropdownRef = useRef(null);
  const dropdownRefTwo = useRef(null);
  const dropdownRefThree = useRef(null)
  const startInput = useRef();
  const endInput = useRef();

  const startDateInput = useRef();
  const endDateInput = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !event.target.closest(".dropdown-menu")
      ) {
        setIsOpen("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  

 
  const startIndex = (currentPage - 1) * pageSizeNew;
  const endIndex = startIndex + pageSizeNew;
  const updateCurrentData = currentData.slice(startIndex, endIndex);
  
  
  const [showPrevButton, setPrevButton] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [arrayIndex, setArrayIndex] = useState(0);

  const handleHide = () => {
    setPageNumber((prev) => prev - 1);
    setArrayIndex((prev) => prev - 10);
    if (pageNumber - 1 >= 0) {
      if (inputValue == 1) {
        purchaseOrderCtl.allBySourceTypeId(2, pageNumber - 1, size, (data) => {
          if (data && !data.error) {
            let orders = data?.content.map((order) => ({
              ...order,
              status: `${order.status}`,
              currency:
                currencies.find((currency) => currency?.id === order.currencyId)
                  ?.code ?? "N.A.",
            }));

            setCurrentData(orders);
            setCurentList(orders);
            setLoading(false);
            setTotalPages(data.totalPages);
            if (data.last == true) {
              setShowButton(false);
            } else {
              setShowButton(true);
            }
            if (data.number == 0) {
              setPrevButton(false);
            } else {
              setPrevButton(true);
            }
          } else {
            Notify(alert, "danger", data.errorMessage ?? data.error);
          }
        });
      } else if (inputValue > 1) {
        purchaseOrderCtl.allByPurchaseSourceBySourceTypeId(
          inputValue,
          2,
          pageNumber - 1,
          size,
          (data) => {
            if (data && !data.error) {
              let orders = data?.content.map((order) => ({
                ...order,
                status: `${order.status}`,
                currency:
                  currencies.find(
                    (currency) => currency?.id === order.currencyId
                  )?.code ?? "N.A.",
              }));
              setCurrentData(orders);
              setCurentList(orders);
              setTotalPages(data.totalPages);
              setLoading(false);
              if (data.last == true) {
                setShowButton(false);
              } else {
                setShowButton(true);
              }
              if (data.number == 0) {
                setPrevButton(false);
              } else {
                setPrevButton(true);
              }
            } else {
              Notify(alert, "danger", data.errorMessage ?? data.error);
            }
          }
        );
      }
    }
  };
  const handleShow = () => {
    setPageNumber((prev) => prev + 1);
    setArrayIndex((prev) => prev + 10);

    if (inputValue == 1) {
      purchaseOrderCtl.allBySourceTypeId(2, pageNumber + 1, size, (data) => {
        if (data && !data.error) {
          let orders = data?.content.map((order) => ({
            ...order,
            status: `${order.status}`,
            currency:
              currencies.find((currency) => currency?.id === order.currencyId)
                ?.code ?? "N.A.",
          }));

          setCurrentData(orders);
          setCurentList(orders);
          setLoading(false);
          setTotalPages(data.totalPages);
          if (data.last == true) {
            setShowButton(false);
          } else {
            setShowButton(true);
          }
          if (data.number == 0) {
            setPrevButton(false);
          } else {
            setPrevButton(true);
          }
        } else {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        }
      });
    } else if (inputValue > 1) {
      purchaseOrderCtl.allByPurchaseSourceBySourceTypeId(
        inputValue,
        2,
        pageNumber + 1,
        size,
        (data) => {
          if (data && !data.error) {
            let orders = data?.content.map((order) => ({
              ...order,
              status: `${order.status}`,
              currency:
                currencies.find((currency) => currency?.id === order.currencyId)
                  ?.code ?? "N.A.",
            }));
            setCurrentData(orders);
            setCurentList(orders);
            setTotalPages(data.totalPages);
            setLoading(false);
            if (data.last == true) {
              setShowButton(false);
            } else {
              setShowButton(true);
            }
            if (data.number == 0) {
              setPrevButton(false);
            } else {
              setPrevButton(true);
            }
          } else {
            Notify(alert, "danger", data.errorMessage ?? data.error);
          }
        }
      );
    }
  };

  const handlePageChange = (Number) => {
    setCurrentPage(Number);
    setSelectedRows([])
    setSelectedNames([])
  };

  const openModel = () => {
		setIsDownloadModalOpen(!isDownloadModalOpen);
    setStartDate('')
		setEndDate('')
	
	}


  const handleDate = (e) => {
      if (e.target.id === "startDate") {
        const selectedStartDate = new Date(e.target.value);
        
        
       
      
        setStartDate(e.target.value);
        setEndDate(null);
        endDateInput.current.value = "";
        endDateInput.current.select();
      } else {
        if (!startDate) {
        Notify(alert, "danger", "First select a start date");
        endDateInput.current.value = "";
        startDateInput.current.focus();
        return;
        }
        
      
        const selectedEndDate = new Date(e.target.value);
        const maxAllowedEndDate = new Date(startDate);
        maxAllowedEndDate.setDate(maxAllowedEndDate.getDate() + 31); // 3 months = 93 days
      
        
        // if (selectedEndDate > maxAllowedEndDate) {
        // Notify(alert, "danger", "End date cannot be more than 1 months  from the start date.");
        // endDateInput.current.value = "";
        // return;
        // }
      
        setEndDate(e.target.value);
      }
      };

      const handleDownloadFile = () =>{
        if(inputValue === 1){
          setButtonLoading(true)
          if(startDate && endDate){
            purchaseOrderCtl.downloadReportAdminAll(startDate,endDate,(data)=>{
              if(data && !data.error){
                setTimeout(() => {
                  setButtonLoading(false)
                }, 1000);
                toggleconfirmSalesReport()
                openModel()
              }else{
                setTimeout(() => {
                  setButtonLoading(false)
                }, 1000);
                Notify(alert,"danger",data?.errorMessage ?? data?.error)
              }
            })
            
          }else{
            setButtonLoading(false)
            Notify(alert,"danger","Plese select date range first")
          }
        }else if(inputValue > 1){
          setButtonLoading(true)
          if(startDate && endDate){
            purchaseOrderCtl.downloadReportAdmin(inputValue,startDate,endDate,(data)=>{
              if(data && !data.error){
                setTimeout(() => {
                  setButtonLoading(false)
                }, 1000);
                toggleconfirmSalesReport()
                openModel()
              }else{
                setTimeout(() => {
                  setButtonLoading(false)
                }, 1000);
                Notify(alert,"danger",data?.errorMessage ?? data?.error)
              }
            })

          }else{
            setButtonLoading(false)
            Notify(alert,"danger","Plese select date range first")
          }
        }else{
          setButtonLoading(false)
        }
      }

  const drawTable = (input) => {
    setInputValue(input?.value);
    setUpdateTable(false);
    setLoading(true);
    if (input?.value === 1) {
      purchaseOrderCtl.allBySourceTypeId(2, pageNumber, size, (data) => {
        if (data && !data.error) {
          let orders = data?.content.map((order) => ({
            ...order,
            status: `${order.status}`,
            currency:
              currencies.find((currency) => currency?.id === order.currencyId)
                ?.code ?? "N.A.",
          }));

          setCurrentData(orders);
          setCurentList(orders);
          setLoading(false);
          setTotalPages(data.totalPages);
          if (data.last == true) {
            setShowButton(false);
          } else {
            setShowButton(true);
          }
        } else {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        }
      });
      purchaseOrderCtl.allGlobalsearch(2, (data) => {
        if (data && !data.error) {
          let orders = data.map((order) => ({
            ...order,
            status: `${order.status}`,
            currency:
              currencies.find((currency) => currency?.id === order.currencyId)
                ?.code ?? "N.A.",
          }));

          setAllData(orders);
          setLoading(false);
          const uniquePurchasers = [
            ...new Set(data?.map((order) => order.purchaserName)),
          ];
          const options = uniquePurchasers.map((name) => ({
            value: name,
            label: name,
          }));
          setPurName(options);

          const uniqueDates = [
            ...new Set(data?.map((order) => order.createdAt)),
          ];

          const dateOptions = uniqueDates.map((date) => ({
            value: date,
            label: date,
          }));
          setPurDate(dateOptions);

          const uniqueOrder = [...new Set(data?.map((order) => order.name))];
          const orderOptions = uniqueOrder.map((ordername) => ({
            value: ordername,
            label: ordername,
          }));
          setPurOrder(orderOptions);

          const uniqueReference = [
            ...new Set(data?.map((order) => order.orderReference)),
          ];
          const refOptions = uniqueReference.map((ref) => ({
            value: ref,
            label: ref,
          }));
          setOrderRef(refOptions);

          const statusLabels = {
            1: (
              <span className="badge badge-pill text-white bg-info">Open</span>
            ),
            2: (
              <span className="badge badge-pill text-white bg-nileBlue">
                In progress
              </span>
            ),
            3: (
              <span className="badge badge-pill text-white bg-radicalRed">
                Cancelled
              </span>
            ),
            4: (
              <span className="badge badge-pill text-white bg-shamrock">
                Completed
              </span>
            ),
            5: (
              <span className="badge badge-pill text-white bg-radicalYellow">
                Processing
              </span>
            ),
            6: (
              <span className="badge badge-pill text-white bg-radicalAssColor">
                API Low Funds
              </span>
            ),
            7: (
              <span className="badge badge-pill text-white bg-radicalAssColor">
                Non API Low Funds
              </span>
            ),
            8: (
              <span className="badge badge-pill text-white bg-radicalOrange">
                Incomplete
              </span>
            ),
            9: (
              <span className="badge badge-pill text-white bg-radicalAssColor">
                Api Invoice
              </span>
            ),
            10: (
              <span className="badge badge-pill text-white bg-radicalAssColor">
                Non Api Invoice
              </span>
            ),
            11: (
              <span className="badge badge-pill text-white bg-radicalOrange">
                API Issue
              </span>
            ),
            12: (
              <span className="badge badge-pill text-white bg-radicalOrange">
                CSV Mismatched
              </span>
            ),
            14: (
              <span className="badge badge-pill text-white bg-radicalOrange">
                ERROR
              </span>
            ),
            15: (
              <span className="badge badge-pill text-white bg-radicalRed">
                Temporary out of stock
              </span>
            ),
            16: (
              <span className="badge badge-pill text-white bg-radicalYellow">
               Pending Approval
              </span> 
            ),
            17:(
               <span className="badge badge-pill text-white bg-radicalYellow">
               Imcomplete Pending Approval
              </span> 
            )
          };

          const uniqueStatusValues = [
            ...new Set(data?.map((order) => order.status)),
          ];
          const statusOptions = uniqueStatusValues.map((status) => ({
            value: status,
            label: statusLabels[status],
          }));

          setPurStatus(statusOptions);
        } else {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        }
      });
    } else if (input?.value > 1) {
      purchaseOrderCtl.allByPurchaseSourceBySourceTypeId(
        input?.value,
        2,
        pageNumber,
        size,
        (data) => {
          if (data && !data.error) {
            let orders = data?.content.map((order) => ({
              ...order,
              status: `${order.status}`,
              currency:
                currencies.find((currency) => currency?.id === order.currencyId)
                  ?.code ?? "N.A.",
            }));

            setCurrentData(orders);
            setCurentList(orders);
            setTotalPages(data.totalPages);
            setLoading(false);
            if (data.last == true) {
              setShowButton(false);
            } else {
              setShowButton(true);
            }
          } else {
            Notify(alert, "danger", data.errorMessage ?? data.error);
          }
        }
      );

      purchaseOrderCtl.allByPurchaserSourceBySourceTypeIdAll(
        input?.value,
        2,
        (data) => {
          if (data && !data.error) {
            let orders = data.map((order) => ({
              ...order,
              status: `${order.status}`,
              currency:
                currencies.find((currency) => currency?.id === order.currencyId)
                  ?.code ?? "N.A.",
            }));
            setAllData(orders);
            setLoading(false);
            const uniquePurchasers = [
              ...new Set(data?.map((order) => order.purchaserName)),
            ];
            const options = uniquePurchasers.map((name) => ({
              value: name,
              label: name,
            }));
            setPurName(options);

            const uniqueDates = [
              ...new Set(data?.map((order) => order.createdAt)),
            ];

            const dateOptions = uniqueDates.map((date) => ({
              value: date,
              label: date,
            }));
            setPurDate(dateOptions);

            const uniqueOrder = [...new Set(data?.map((order) => order.name))];
            const orderOptions = uniqueOrder.map((ordername) => ({
              value: ordername,
              label: ordername,
            }));
            setPurOrder(orderOptions);

            const uniqueReference = [
              ...new Set(data?.map((order) => order.orderReference)),
            ];
            const refOptions = uniqueReference.map((ref) => ({
              value: ref,
              label: ref,
            }));
            setOrderRef(refOptions);

            const statusLabels = {
              1: (
                <span className="badge badge-pill text-white bg-info">
                  Open
                </span>
              ),
              2: (
                <span className="badge badge-pill text-white bg-nileBlue">
                  In progress
                </span>
              ),
              3: (
                <span className="badge badge-pill text-white bg-radicalRed">
                  Cancelled
                </span>
              ),
              4: (
                <span className="badge badge-pill text-white bg-shamrock">
                  Completed
                </span>
              ),
              5: (
                <span className="badge badge-pill text-white bg-radicalYellow">
                  Processing
                </span>
              ),
              6: (
                <span className="badge badge-pill text-white bg-radicalAssColor">
                  API Low Funds
                </span>
              ),
              7: (
                <span className="badge badge-pill text-white bg-radicalAssColor">
                  Non API Low Funds
                </span>
              ),
              8: (
                <span className="badge badge-pill text-white bg-radicalOrange">
                  Incomplete
                </span>
              ),
              9: (
                <span className="badge badge-pill text-white bg-radicalAssColor">
                  Api Invoice
                </span>
              ),
              10: (
                <span className="badge badge-pill text-white bg-radicalAssColor">
                  Non Api Invoice
                </span>
              ),
              11: (
                <span className="badge badge-pill text-white bg-radicalOrange">
                  API Issue
                </span>
              ),
              12: (
                <span className="badge badge-pill text-white bg-radicalOrange">
                  CSV Mismatched
                </span>
              ),
              14: (
                <span className="badge badge-pill text-white bg-radicalOrange">
                  ERROR
                </span>
              ),
              15: (
                <span className="badge badge-pill text-white bg-radicalRed">
                  Temporary out of stock
                </span>
              ),
              16: (
                <span className="badge badge-pill text-white bg-radicalYellow">
                 Pending Approval
                </span> 
              ),
              17:(
              <span className="badge badge-pill text-white bg-radicalYellow">
               Imcomplete Pending Approval
              </span> 
              )
            };

            const uniqueStatusValues = [
              ...new Set(data?.map((order) => order.status)),
            ];
            const statusOptions = uniqueStatusValues.map((status) => ({
              value: status,
              label: statusLabels[status],
            }));

            setPurStatus(statusOptions);
          } else {
            Notify(alert, "danger", data.errorMessage ?? data.error);
          }
        }
      );
    } else {
      setCurrentData([]);
      setCurentList([]);
      setTotalPages(0);
      setPageNumber(0);
      setCurrentPage(1);
      setArrayIndex(0);
      setPrevButton(false);
      setShowButton(false);
      setPurName([]);
      setPurDate([]);
      setPurOrder([]);
      setPurStatus([]);
      setOrderRef([]);
      setSelectedRows([])
      setSelectShow(false)
      setFilterActive(false)
    }
  };


  const RetriveData = () =>{
    setLoader(true)
    if (inputValue === 1) {
      
      purchaseOrderCtl.allBySourceTypeId(2, pageNumber, size, (data) => {
        if (data && !data.error) {
          let orders = data?.content.map((order) => ({
            ...order,
            status: `${order.status}`,
            currency:
              currencies.find((currency) => currency?.id === order.currencyId)
                ?.code ?? "N.A.",
          }));
          setLoader(false)
          setCurrentData(orders);
          setCurentList(orders);
          setLoading(false);
          setTotalPages(data.totalPages);
          if (data.last == true) {
            setShowButton(false);
          } else {
            setShowButton(true);
          }
        } else {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        }
      });
      purchaseOrderCtl.allGlobalsearch(2, (data) => {
        if (data && !data.error) {
          let orders = data.map((order) => ({
            ...order,
            status: `${order.status}`,
            currency:
              currencies.find((currency) => currency?.id === order.currencyId)
                ?.code ?? "N.A.",
          }));
          
          setAllData(orders);
          setLoading(false);
          const uniquePurchasers = [
            ...new Set(data?.map((order) => order.purchaserName)),
          ];
          const options = uniquePurchasers.map((name) => ({
            value: name,
            label: name,
          }));
          setPurName(options);

          const uniqueDates = [
            ...new Set(data?.map((order) => order.createdAt)),
          ];

          const dateOptions = uniqueDates.map((date) => ({
            value: date,
            label: date,
          }));
          setPurDate(dateOptions);

          const uniqueOrder = [...new Set(data?.map((order) => order.name))];
          const orderOptions = uniqueOrder.map((ordername) => ({
            value: ordername,
            label: ordername,
          }));
          setPurOrder(orderOptions);

          const uniqueReference = [
            ...new Set(data?.map((order) => order.orderReference)),
          ];
          const refOptions = uniqueReference.map((ref) => ({
            value: ref,
            label: ref,
          }));
          setOrderRef(refOptions);

          const statusLabels = {
            1: (
              <span className="badge badge-pill text-white bg-info">Open</span>
            ),
            2: (
              <span className="badge badge-pill text-white bg-nileBlue">
                In progress
              </span>
            ),
            3: (
              <span className="badge badge-pill text-white bg-radicalRed">
                Cancelled
              </span>
            ),
            4: (
              <span className="badge badge-pill text-white bg-shamrock">
                Completed
              </span>
            ),
            5: (
              <span className="badge badge-pill text-white bg-radicalYellow">
                Processing
              </span>
            ),
            6: (
              <span className="badge badge-pill text-white bg-radicalAssColor">
                API Low Funds
              </span>
            ),
            7: (
              <span className="badge badge-pill text-white bg-radicalAssColor">
                Non API Low Funds
              </span>
            ),
            8: (
              <span className="badge badge-pill text-white bg-radicalOrange">
                Incomplete
              </span>
            ),
            9: (
              <span className="badge badge-pill text-white bg-radicalAssColor">
                Api Invoice
              </span>
            ),
            10: (
              <span className="badge badge-pill text-white bg-radicalAssColor">
                Non Api Invoice
              </span>
            ),
            11: (
              <span className="badge badge-pill text-white bg-radicalOrange">
                API Issue
              </span>
            ),
            12: (
              <span className="badge badge-pill text-white bg-radicalOrange">
                CSV Mismatched
              </span>
            ),
            14: (
              <span className="badge badge-pill text-white bg-radicalOrange">
                ERROR
              </span>
            ),
            15: (
              <span className="badge badge-pill text-white bg-radicalRed">
                Temporary out of stock
              </span>
            ),
            16: (
              <span className="badge badge-pill text-white bg-radicalYellow">
               Pending Approval
              </span> 
            ),
            17:(
               <span className="badge badge-pill text-white bg-radicalYellow">
               Imcomplete Pending Approval
              </span> 
            )
          };

          const uniqueStatusValues = [
            ...new Set(data?.map((order) => order.status)),
          ];
          const statusOptions = uniqueStatusValues.map((status) => ({
            value: status,
            label: statusLabels[status],
          }));

          setPurStatus(statusOptions);
        } else {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        }
      });
    } else if (inputValue > 1) {
      purchaseOrderCtl.allByPurchaseSourceBySourceTypeId(
        inputValue,
        2,
        pageNumber,
        size,
        (data) => {
          if (data && !data.error) {
            let orders = data?.content.map((order) => ({
              ...order,
              status: `${order.status}`,
              currency:
                currencies.find((currency) => currency?.id === order.currencyId)
                  ?.code ?? "N.A.",
            }));
            setLoader(false)
            setCurrentData(orders);
            setCurentList(orders);
            setTotalPages(data.totalPages);
            setLoading(false);
            if (data.last == true) {
              setShowButton(false);
            } else {
              setShowButton(true);
            }
          } else {
            Notify(alert, "danger", data.errorMessage ?? data.error);
          }
        }
      );

      purchaseOrderCtl.allByPurchaserSourceBySourceTypeIdAll(
        inputValue,
        2,
        (data) => {
          if (data && !data.error) {
            let orders = data.map((order) => ({
              ...order,
              status: `${order.status}`,
              currency:
                currencies.find((currency) => currency?.id === order.currencyId)
                  ?.code ?? "N.A.",
            }));
            setAllData(orders);
            setLoading(false);
            const uniquePurchasers = [
              ...new Set(data?.map((order) => order.purchaserName)),
            ];
            const options = uniquePurchasers.map((name) => ({
              value: name,
              label: name,
            }));
            setPurName(options);

            const uniqueDates = [
              ...new Set(data?.map((order) => order.createdAt)),
            ];

            const dateOptions = uniqueDates.map((date) => ({
              value: date,
              label: date,
            }));
            setPurDate(dateOptions);

            const uniqueOrder = [...new Set(data?.map((order) => order.name))];
            const orderOptions = uniqueOrder.map((ordername) => ({
              value: ordername,
              label: ordername,
            }));
            setPurOrder(orderOptions);

            const uniqueReference = [
              ...new Set(data?.map((order) => order.orderReference)),
            ];
            const refOptions = uniqueReference.map((ref) => ({
              value: ref,
              label: ref,
            }));
            setOrderRef(refOptions);

            const statusLabels = {
              1: (
                <span className="badge badge-pill text-white bg-info">
                  Open
                </span>
              ),
              2: (
                <span className="badge badge-pill text-white bg-nileBlue">
                  In progress
                </span>
              ),
              3: (
                <span className="badge badge-pill text-white bg-radicalRed">
                  Cancelled
                </span>
              ),
              4: (
                <span className="badge badge-pill text-white bg-shamrock">
                  Completed
                </span>
              ),
              5: (
                <span className="badge badge-pill text-white bg-radicalYellow">
                  Processing
                </span>
              ),
              6: (
                <span className="badge badge-pill text-white bg-radicalAssColor">
                  API Low Funds
                </span>
              ),
              7: (
                <span className="badge badge-pill text-white bg-radicalAssColor">
                  Non API Low Funds
                </span>
              ),
              8: (
                <span className="badge badge-pill text-white bg-radicalOrange">
                  Incomplete
                </span>
              ),
              9: (
                <span className="badge badge-pill text-white bg-radicalAssColor">
                  Api Invoice
                </span>
              ),
              10: (
                <span className="badge badge-pill text-white bg-radicalAssColor">
                  Non Api Invoice
                </span>
              ),
              11: (
                <span className="badge badge-pill text-white bg-radicalOrange">
                  API Issue
                </span>
              ),
              12: (
                <span className="badge badge-pill text-white bg-radicalOrange">
                  CSV Mismatched
                </span>
              ),
              14: (
                <span className="badge badge-pill text-white bg-radicalOrange">
                  ERROR
                </span>
              ),
              15: (
                <span className="badge badge-pill text-white bg-radicalRed">
                  Temporary out of stock
                </span>
              ),
              16: (
                <span className="badge badge-pill text-white bg-radicalYellow">
                 Pending Approval
                </span> 
              ),
              17:(
                 <span className="badge badge-pill text-white bg-radicalYellow">
               Imcomplete Pending Approval
              </span> 
              )
            };

            const uniqueStatusValues = [
              ...new Set(data?.map((order) => order.status)),
            ];
            const statusOptions = uniqueStatusValues.map((status) => ({
              value: status,
              label: statusLabels[status],
            }));

            setPurStatus(statusOptions);
          } else {
            Notify(alert, "danger", data.errorMessage ?? data.error);
          }
        }
      );
    } else {
      setCurrentData([]);
      setCurentList([]);
      setTotalPages(0);
      setPageNumber(0);
      setCurrentPage(1);
      setArrayIndex(0);
      setPrevButton(false);
      setShowButton(false);
      setPurName([]);
      setPurDate([]);
      setPurOrder([]);
      setPurStatus([]);
      setOrderRef([]);
    }
  }
  const prepareDetails = (data) => {
   

    setOrderDetail(data);
    const hasNRT = data.name.includes("NRT");
    setHasNRT(hasNRT);
    setShow((prev) => prev + 1);
    setCheckOrder(data?.name);
    if (hasNRT) {
      setPurchaserName(data.name);
    } else {
      setPurchaserName(data.id);
    }
    toggleDrawer();
  };

  const prepareBatch = (data) => {
    setBatchDetails(data);
    toogleBatchDrawer();
  };
  const [purchaserSourceId, setPurchaserSourceId] = useState("");
  const uploadFile = (row) => {
    let order = row;
    setPurchaserSourceId(order.purchaseSourceId);
    setUploadJson({
      name: order.name,
      quantity: order.totalQuantity,
    });
    setCofrimButton(true);
    toggleModalCSV();
  };

  const dowloadOrderConfirm = () => {
    PoProcessingCtl.purchaseOrderDownloadAdmin(
      rowDownloadData?.name,
      (data) => {
        if (data?.status === 403) {
          toggleWarning();
          return;
        }
        if (data.error || data.errorMessage) {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        } else {
          window.location.assign(data?.downloadLink, "_blank");
          Notify(alert, "success", "Order csv zip download successfully");
          toggleDownload();
        }
      }
    );
  };

  const downloadOrder = (row) => {
    const rowData = row;
    setRowDownloadData(rowData);
    toggleDownload();
  };

  const callApiFunction = (row) => {
    // Use the passed data in your function
    let download = row.data();
    let datas = download.name;
    // Make the API call or perform any other logic
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}private/backoffice/po-processing/downloadCode/${datas}`,
          {
            headers: {
              Authorization: `${token}`,
            },
          }
        );

        if (response.ok) {
          const downloadUrl = await response.text();

          // Initiate file download
          window.open(downloadUrl, "_blank");
        } else {
        }
      } catch (error) {}
    };

    fetchData();
  };

  const cancelOrder = (row) => {
    toggleCancel();
    setOrder(row);
  };

  const confirmCancel = () => {
    purchaseOrderCtl.cancelOrder(order.name, (data) => {
      if (data?.status === 403) {
        toggleWarning();
        toggleCancel();
        return;
      }
      // if (data.error || data.errorMessage) {
      // 	Notify(alert, 'danger', data.errorMessage ?? data.error)
      // } else {

      drawTable({ value: inputValue });
      Notify(alert, "warning", "Order has been Canceled");
      toggleCancel();
      // }
    });
  };

  const confirmCancelAll = () =>{
    const isOnlyThreeOrFour = selectedStatus.every((status) => status === "3" || status === "4");

    if (isOnlyThreeOrFour) {
      Notify(alert, "danger", "Selected Items are alreday cancel or completed cannot be canceled.");
      toggleCancelAll()
      return; 
    }
    setCancelAllLoader(true)
  purchaseOrderCtl.cancelAllOrder(selectedNames,(data)=>{
  if(data && !data?.error){
    Notify(alert,"success","Cancel Selected order successfully")
    setTimeout(() => {
      setCancelAllLoader(false);
    }, 1500);
    toggleCancelAll()
    setSelectedRows([]);
    setSelectedNames([]);
    setIsOpenTwo(false)
    setTimeout(() => {
      RetriveData()
    }, 5000);
  }else{
    Notify(alert,"danger",data?.errorMessage ?? data?.error)
    setTimeout(() => {
      setCancelAllLoader(false);
    }, 1500);
  }
})
  }

const confirmAllRetry = () =>{
  const isOnlyThreeOrFour = selectedStatus.every((status) => status === "3" || status === "4");
  if (isOnlyThreeOrFour) {
    Notify(alert, "danger", "Selected Items are alreday cancel or completed cannot be Rety.");
    toggleRetryAll()
    return; 
  }
  setConfirmAllLoader(true)
  purchaseOrderCtl.retryAllOrder(selectedNames,(data)=>{
    if(data && !data?.error){
      setTimeout(() => {
        setConfirmAllLoader(false)
      }, 1500);
      Notify(alert,"success","Retry Selected order successfully")
      toggleRetryAll()
      setSelectedRows([]);
      setSelectedNames([]);
      setIsOpenTwo(false)
      setTimeout(() => {
        RetriveData()
      }, 5000);
    }else{
     Notify(alert,"danger",data?.errorMessage ?? data?.error)
     setTimeout(() => {
      setConfirmAllLoader(false)
    }, 1500);
    }
  })
}

  const onSelectRow = (row) => {
    let order = row.data();
  };

  const releaseOrder = (row) => {
    toggleRelease();
    setOrder(row);
  };

  const confirmRelease = () => {
    purchaseOrderCtl.releaseOrder(order.name, (data) => {
      if (data?.status === 403) {
        toggleWarning();
        toggleRelease();
        return;
      }
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        drawTable({ value: 1 });
        Notify(alert, "success", "Order has been release");
        toggleRelease();
      }
    });
  };

  const releaseNonApiOrder = (row) => {
    let order = row;
    purchaseOrderCtl.releaseNonApiOrder(order.name, (data) => {
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        drawTable({ value: 1 });
        Notify(alert, "success", "Order has been release");
      }
    });
  };

  const downloadFile = (data, filename) => {
    const csvData = convertToCSV(data);
    const url = window.URL.createObjectURL(new Blob([csvData]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadFileNew = (downloadLink, filename) => {
  const link = document.createElement("a");
  link.href = downloadLink;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  const csvfile = (fileUrl, filename) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", filename || "download");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const convertToCSV = (data) => {
    const header = Object.keys(data[0]).join(",");
    const rows = data.map((obj) => Object.values(obj).join(","));
    return `${header}\n${rows.join("\n")}`;
  };

  const downloadIncompleteOrderfile = (row) => {
    let order = row;
    purchaseOrderCtl.downloadIncompleteOrder(order.name, (data) => {
      if (data?.status === 403) {
        toggleWarning();
        return;
      }
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        csvfile(data.downloadLink, `${order.name}.csv`);
        Notify(alert, "success", "Order csv has been downloaded");
      }
    });
  };

  const downloadCSVFile = () => {
    let orders = rowData;
    purchaseOrderCtl.downloadApiOrder(orders.name, (data) => {
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        downloadFile(data, `${orders.name}.csv`);
        Notify(alert, "success", "Order csv has been downloaded");
      }
    });
  };
  const downloadCSVFileTwo = () => {
    let orders = rowData;
    purchaseOrderCtl.downloadApiOrder(orders.name, (data) => {
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        downloadFile(data, `${orders.name}.csv`);
        Notify(alert, "success", "Order csv has been downloaded");
      }
    });
  };

  const downloadGetFileCSV = () =>{
    let orders = rowData;
    purchaseOrderCtl.downloadGetfile(orders?.name,(data)=>{
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data?.errorMessage ?? data.error);
      } else {
        console.log("data",data);
        
        downloadFileNew(data?.downloadLink, `${orders.name}.csv`);
        Notify(alert, "success", "File csv has been downloaded");
      }
    })
  }


  const retryOrder = (row) => {
    let order = row;
    toggleRetry();
    setOrderData(order);
  };

  const modifyOrder = (data) => {
    setOrderDetail(data);
    setShowTwo((prev) => prev + 1);
    setPurchaserName(data.name);
    toggleModifyDrawer();
  };

  const modifyNRTOrder = (data) =>{
    setShwoThree((prev) => prev + 1);
    toggleModifyNRTDrawer();
    setOrderDetail(data)
    setPurchaserName(data.name);
  }

  const failedOrder = (data) =>{
    toggleRestoreOrder()
    setPurchaserName(data.name);
   }

   const ApiIssueDeatils = (data) =>{
    setOrder(data)
    setApiIssueLoader(true)
    if(data?.name){
      purchaseOrderCtl.failurelog(data?.name,(data)=>{
        if(data && !data.error){
          setApiDetails(data)
          setApiIssueLoader(false)
        }else{
          Notify(alert,"danger",data?.errorMessage ?? data?.error)
        }
      })
    }else{
      setApiIssueLoader(false)
    }
      toggleIssueDeatils()
   }

   const approveOrder = (data) =>{
    setOrder(data)
        toggleApprove()
   }

   const approveFileOrder = (data) =>{
    setOrder(data)
    toggleApproveFile()
   }

   const handleRestoreOrder = () =>{
    setRestoreLoader(true)
  if(purchaserName){
    purchaseOrderCtl.failedOrder(purchaserName,(data)=>{
      if(data && !data?.error){
       Notify(alert,"success",data?.Message)
       toggleRestoreOrder()
      setTimeout(() => {
        setRestoreLoader(false)
      }, 1500);
      }else{
       Notify(alert,"danger",data?.Error ?? data?.error)
       setTimeout(() => {
        setRestoreLoader(false)
       }, 1500);
      }
   })
  }else{
    setRestoreLoader(false)
  }
 }

  const resetPassWord = (data) =>{
    setOrderDetail(data)
    toggleResetPassword()

  }

  const confirmRetry = () => {
    purchaseOrderCtl.retryOrder(orderData.name, (data) => {
      if (data?.status === 403) {
        toggleWarning();
        toggleRetry();
        return;
      }
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        drawTable({ value: orderData.purchaseSourceId });
        Notify(alert, "warning", "Retrying Unprocessed Order!");
        toggleRetry();
      }
    });
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setFileCsv(event.target.files[0]);
  };

  const handleFileChangeNew = (event) =>{
   setSelectedFileNew(event.target.files[0])
   setFileCsvNew(event.target.files[0])
  }
  const handleFileChangeReplace = (event) =>{
     setSelectedFileTwo(event.target.files[0]);
     setFileCsvTwo(event.target.files[0])
  }

  const RepeatFunction = (row) => {
    setRowData(row);
    toggleUpload();
  };
  const ReplaceFunction = (row) =>{
    setRowData(row);
    toggleReplaceUpload()
  }

  const handleFileUpload = (event) => {
    event.preventDefault();
    const fileRowData = rowData;
    const name = fileRowData.name;
    const formData = new FormData();
    formData.append("file", selectedFile);

    if (selectedFile === null) {
      Notify(alert, "danger", "please upload a file");
      return false;
    } else if (selectedFile.length === 0) {
      Notify(alert, "danger", "please upload a file");
      return false;
    } else {
      purchaserCtl.uploadCSVRealtime(name, formData, (data) => {
        if (data.error || data.errorMessage) {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        } else {
          Notify(alert, "success", "Order csv has been Uploaded");
          setTimeout(() => {
            toggleConfimCsv()
            toggleUpload();
            setFileCsv("");
          }, 1000);
        }
      });
    }
  };

  const handleFileNewUpload = (event) =>{
    event.preventDefault();
    const fileRowData = rowData;
    const name = fileRowData.name;
     const formData = new FormData();
    formData.append("file", selectedFileNew);

    if (selectedFileNew === null) {
      Notify(alert, "danger", "please upload a file");
      return false;
    } else if (selectedFileNew.length === 0) {
      Notify(alert, "danger", "please upload a file");
      return false;
    } else {
      purchaserCtl.uploadCSVRealtime(name, formData, (data) => {
        if (data.error || data.errorMessage) {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        } else {
          Notify(alert, "success", "Order csv has been Uploaded");
          setTimeout(() => {
            toggleConfimCsv()
            toggleUpload();
            setFileCsv("");
          }, 1000);
        }
      });
    }
  }

  const handleFileUploadTwo = (event) =>{
    event.preventDefault();
    const fileRowData = rowData;
    const name = fileRowData.name;
    const formData = new FormData();
    formData.append("file", selectedFileTwo);
    toggleConfimCsvTwo()
    if (selectedFileTwo === null) {
      Notify(alert, "danger", "please upload a file");
      return false;
    } else if (selectedFileTwo.length === 0) {
      Notify(alert, "danger", "please upload a file");
      return false;
    } else {
      purchaserCtl.uploadCSVRealtime(name, formData, (data) => {
        if (data.error || data.errorMessage) {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        } else {
          Notify(alert, "success", "Order csv has been Uploaded");
          setTimeout(() => {
            toggleConfimCsvTwo()
            toggleReplaceUpload();
            setFileCsv("");
          }, 1000);
        }
      });
    }
  }

  const handleResetPassword = () =>{
    if(accessRoles.includes("ACCOUNTANT_MANAGER") ||  accessRoles.includes("COMMERCIAL_MANAGER") || accessRoles.includes("CUSTOMER_SERVICE") || accessRoles.includes("INTERNAL") || accessRoles.includes("PRODUCT_MANAGER") || accessRoles.includes("SUPPLIER_MANAGER")) {
      toggleWarning();
      return;
    }
    
    purchaserCtl.resetPassword(orderDetail?.name,(data)=>{
      if(data && !data?.error){
        if(data?.status === false){
          Notify(alert,"danger",data?.message)
        }
        toggleResetPassword();
        Notify(alert,"success","Password regeneration is successfull.");
      }else{
        Notify(alert,"danger",data?.errorMessage ?? data?.error)
      }
    })
    
  }

  useEffect(() => {
    brandsCtl.all((data) => {
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        setBrands(data);
      }
    });

    cardTypeCtl.all((data) => {
      if (data.error || data.errorMessage) {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      } else {
        setCardTypes(data);
      }
    });
  }, [brandsCtl, cardTypeCtl]);

  useEffect(() => {
    purchaserCtl.all((data) => {
      const sortedData = data.sort((a, b) =>
        a.name.toUpperCase() < b.name.toUpperCase()
          ? -1
          : a.name.toUpperCase() > b.name.toUpperCase()
          ? 1
          : 0
      );
      if (data && !data.error) {
        setPurchasers([
          ...purchasers,
          ...sortedData.map((purchaser) => ({
            value: purchaser.id,
            label: purchaser.name,
          })),
        ]);
      } else {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      }
    });
  }, [purchaserCtl]);

  useEffect(() => {
    if (saveCsv == true) {
      drawTable({ value: purchaserSourceId });
      setSaveCsv(false);
      setPurchaserSourceId("");
    }
  }, [saveCsv]);

  const [allData, setAllData] = useState([]);



  const handleGlobalSearch = (event) => {
    setGlobalSearch(event.target.value);
    if (!event.target.value) {
      setCurrentData(currentList);
      setFilterActive(false);
    } else {
      const searchResults = allData?.filter((item) => {
        const values = Object.values(item);
        return values.some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(event.target.value.toLowerCase())
        );
      });

      setFilterActive(true);
      setCurrentData(searchResults);
      setCurrentPage(1);
      return searchResults.length > 0 ? searchResults : "No match found";
    }
  };

  const nameFilter = (selectedOptions) => {
    if (selectedOptions && selectedOptions.length > 0) {
      const selectedValues = selectedOptions.map((option) => option.value);
      const filteredData = allData?.filter((order) =>
        selectedValues.includes(order.purchaserName)
      );

      filteredData.forEach((order) => {
        order.createdAt = new Date(order.createdAt).toLocaleString();
      });

      filteredData.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setFilterActive(true);
      setCurrentPage(1);
      setCurrentData(filteredData);
    } else {
      setCurrentData(currentList);
      setFilterActive(false);
    }
  };

  const dateFilter = (seletoption) => {
    if (seletoption && seletoption.length > 0) {
      const selectedValues = seletoption.map((option) => option.value);
      const datefilterData = allData?.filter((order) =>
        selectedValues.includes(order.createdAt)
      );
      setFilterActive(true);
      setCurrentData(datefilterData);
      setCurrentPage(1);
    } else {
      setCurrentData(currentList);
      setFilterActive(false);
    }
  };

  const orderFilter = (options) => {
    if (options && options.length > 0) {
      const selectedValues = options.map((option) => option.value);
      const filterData = allData?.filter((order) =>
        selectedValues.includes(order.name)
      );
      setFilterActive(true);
      setCurrentData(filterData);
      setCurrentPage(1);
    } else {
      setCurrentData(currentList);
      setFilterActive(false);
    }
  };

  const refFilter = (options) => {
    if (options && options.length > 0) {
      const selectedValues = options.map((option) => option.value);
      const filterData = allData?.filter((order) =>
        selectedValues.includes(order.orderReference)
      );
      setFilterActive(true);
      setCurrentData(filterData);
      setCurrentPage(1);
    } else {
      setCurrentData(currentList);
      setFilterActive(false);
    }
  };

  const statusFilter = (statusoption) => {
    if (statusoption && statusoption.length > 0) {
      const selectedValues = statusoption.map((option) => String(option.value));
      const filterData = allData?.filter((order) => {
        const orderStatusString = String(order.status);
        return selectedValues.includes(orderStatusString);
      });

      filterData.forEach((order) => {
        order.createdAt = new Date(order.createdAt).toLocaleString();
      });

      filterData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      setFilterActive(true);
      setCurrentData(filterData);
      setCurrentPage(1);
    } else {
      setCurrentData(currentList);
      setFilterActive(false);
    }
  };

  const [isOpen, setIsOpen] = useState("");

  const toggleDropdown = (index) => {
    setIsOpen((prevState) => (prevState === index ? "" : index));
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  const handleCancelReplaceUpload = () => {
    setSelectedFileTwo(null);
    toggleReplaceUpload();
    setFileCsvTwo(null)
  };
const openDrawerRow = (data) =>{
  setLoaderTwo(true)
  setNestedData([])
  setOpenDrawerId((prevId) => (prevId === data?.id ? null : data?.id));
  purchaseOrderCtl.purchaseOrderDetailAdmin(data?.id,(data)=>{
    if (data?.status === 403) {
      toggleWarning();
      return;
    }
    if(data && !data.error){
      setNestedData(data)
      setLoaderTwo(false)
    }else{
       if (data?.error !== 'Server error response code: 400. Unable to parse response body.') {
        Notify(alert, 'danger', data.errorMessage ?? data.error);
        }
        setTimeout(() => {
        setLoaderTwo(false)  
        }, 500);
    }
  })
}
const handleOptionClick = (value) => {
  // Update rows per page and page size
  setRowsPerPage(value);
  setPageSizeNew(value);
  setShowDropdown(false);

  
  const startIndex = (currentPage - 1) * value;
  const endIndex = startIndex + value;
  const newUpdateCurrentData = currentData.slice(startIndex, endIndex);

  
  const updatedSelectedRowsForCurrentPage = selectedRows.filter((id) =>
    newUpdateCurrentData.some((row) => row.id === id)
  );

  const updatedSelectedNamesForCurrentPage = selectedNames.filter((name) =>
    newUpdateCurrentData.some((row) => row.name === name)
  );

  // Update the selected rows state with the filtered list
  setSelectedRows(updatedSelectedRowsForCurrentPage);
  setSelectedNames(updatedSelectedNamesForCurrentPage)
};


const handleClickOutside = (event) => {
  if (dropdownRefTwo.current && !dropdownRefTwo.current.contains(event.target)) {
    setShowDropdown(false); // Close dropdown when clicking outside
  }
};

useEffect(() => {
  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

const handleClickOutsideTwo = (event) => {
  if (dropdownRefThree.current && !dropdownRefThree.current.contains(event.target)) {
    setIsOpen(false); // Close dropdown when clicking outside
  }
};

useEffect(() => {
  document.addEventListener("mousedown", handleClickOutsideTwo);
  return () => {
    document.removeEventListener("mousedown", handleClickOutsideTwo);
  };
}, []);

const handleChangeCheck = (data, e) => {
  const updatedSelectedRows = [...selectedRows];
  const updatedSelectedNames = [...selectedNames];
  const updateSelectedStatus = [...selectedStatus]
  const index = updatedSelectedRows.indexOf(data.id);
  const nameIndex = updatedSelectedNames.indexOf(data.name);
  const statusIndex = updateSelectedStatus.indexOf(data?.status)

  if (e.target.checked && index === -1) {
    // Add to selected rows and names
    updatedSelectedRows.push(data.id);
    updatedSelectedNames.push(data.name);
    updateSelectedStatus.push(data.status)
  } else if (!e.target.checked && index !== -1) {
    // Remove from selected rows and names
    updatedSelectedRows.splice(index, 1);
    updatedSelectedNames.splice(nameIndex, 1);
    updateSelectedStatus.splice(statusIndex,1)
  }

  setSelectedRows(updatedSelectedRows);
  setSelectedNames(updatedSelectedNames);
  setSelectedStatus(updateSelectedStatus)
};

useEffect(() => {
  if (showApplyButton) {
    setOpenModifyDrawer(true); 
  } else {
    setOpenModifyDrawer(false); 
  }
}, [showApplyButton]);

const handleToggleDrawer = (isOpen) => {
 
  if (showApplyButton) {
    setOpenModifyDrawer(true); 
  } else {
    setOpenModifyDrawer(isOpen); 
  }

  
  if (!isOpen && !showApplyButton) {
    setShowApplyButton(false);
  }
};

const handleSelectAll = (e) => {
  if (e.target.checked) {
    const allRowIds = updateCurrentData.map((row) => row.id);
    const allRowNames = updateCurrentData.map((row) => row.name);
    const allowStatus = updateCurrentData.map((row)=> row.status)

    setSelectedRows(allRowIds);
    setSelectedNames(allRowNames);
    setSelectedStatus(allowStatus)
  } else {
    // Deselect all rows and names
    setSelectedRows([]);
    setSelectedNames([]);
    setSelectedStatus([])
  }
};

const toggleDropdownThree = () =>{
  setIsOpenTwo(!isOpenTwo)
}

const cancelOrderAll = () =>{
toggleCancelAll()
}

const retryOrderAll = () =>{
toggleRetryAll()
}


 const resetSearch = () =>{
  startInput.current.value = '';
  endInput.current.value = '';
  setFilterActive(false)
  setStartDateTwo('')
  setEndDateTwo('')
  if (inputValue === 1) {
      
    purchaseOrderCtl.allBySourceTypeId(2, pageNumber, size, (data) => {
      if (data && !data.error) {
        let orders = data?.content.map((order) => ({
          ...order,
          status: `${order.status}`,
          currency:
            currencies.find((currency) => currency?.id === order.currencyId)
              ?.code ?? "N.A.",
        }));
        setLoader(false)
        setCurrentData(orders);
        setCurentList(orders);
        setLoading(false);
        setTotalPages(data.totalPages);
        if (data.last == true) {
          setShowButton(false);
        } else {
          setShowButton(true);
        }
      } else {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      }
    });
    purchaseOrderCtl.allGlobalsearch(2, (data) => {
      if (data && !data.error) {
        let orders = data.map((order) => ({
          ...order,
          status: `${order.status}`,
          currency:
            currencies.find((currency) => currency?.id === order.currencyId)
              ?.code ?? "N.A.",
        }));
        
        setAllData(orders);
        setLoading(false);
        const uniquePurchasers = [
          ...new Set(data?.map((order) => order.purchaserName)),
        ];
        const options = uniquePurchasers.map((name) => ({
          value: name,
          label: name,
        }));
        setPurName(options);

        const uniqueDates = [
          ...new Set(data?.map((order) => order.createdAt)),
        ];

        const dateOptions = uniqueDates.map((date) => ({
          value: date,
          label: date,
        }));
        setPurDate(dateOptions);

        const uniqueOrder = [...new Set(data?.map((order) => order.name))];
        const orderOptions = uniqueOrder.map((ordername) => ({
          value: ordername,
          label: ordername,
        }));
        setPurOrder(orderOptions);

        const uniqueReference = [
          ...new Set(data?.map((order) => order.orderReference)),
        ];
        const refOptions = uniqueReference.map((ref) => ({
          value: ref,
          label: ref,
        }));
        setOrderRef(refOptions);

        const statusLabels = {
          1: (
            <span className="badge badge-pill text-white bg-info">Open</span>
          ),
          2: (
            <span className="badge badge-pill text-white bg-nileBlue">
              In progress
            </span>
          ),
          3: (
            <span className="badge badge-pill text-white bg-radicalRed">
              Cancelled
            </span>
          ),
          4: (
            <span className="badge badge-pill text-white bg-shamrock">
              Completed
            </span>
          ),
          5: (
            <span className="badge badge-pill text-white bg-radicalYellow">
              Processing
            </span>
          ),
          6: (
            <span className="badge badge-pill text-white bg-radicalAssColor">
              API Low Funds
            </span>
          ),
          7: (
            <span className="badge badge-pill text-white bg-radicalAssColor">
              Non API Low Funds
            </span>
          ),
          8: (
            <span className="badge badge-pill text-white bg-radicalOrange">
              Incomplete
            </span>
          ),
          9: (
            <span className="badge badge-pill text-white bg-radicalAssColor">
              Api Invoice
            </span>
          ),
          10: (
            <span className="badge badge-pill text-white bg-radicalAssColor">
              Non Api Invoice
            </span>
          ),
          11: (
            <span className="badge badge-pill text-white bg-radicalOrange">
              API Issue
            </span>
          ),
          12: (
            <span className="badge badge-pill text-white bg-radicalOrange">
              CSV Mismatched
            </span>
          ),
          14: (
            <span className="badge badge-pill text-white bg-radicalOrange">
              ERROR
            </span>
          ),
          15: (
            <span className="badge badge-pill text-white bg-radicalRed">
              Temporary out of stock
            </span>
          ),
          16: (
            <span className="badge badge-pill text-white bg-radicalYellow">
             Pending Approval
            </span> 
          ),
          17:(
             <span className="badge badge-pill text-white bg-radicalYellow">
               Imcomplete Pending Approval
              </span> 
          )
        };

        const uniqueStatusValues = [
          ...new Set(data?.map((order) => order.status)),
        ];
        const statusOptions = uniqueStatusValues.map((status) => ({
          value: status,
          label: statusLabels[status],
        }));

        setPurStatus(statusOptions);
      } else {
        Notify(alert, "danger", data.errorMessage ?? data.error);
      }
    });
  } else if (inputValue > 1) {
    purchaseOrderCtl.allByPurchaseSourceBySourceTypeId(
      inputValue,
      2,
      pageNumber,
      size,
      (data) => {
        if (data && !data.error) {
          let orders = data?.content.map((order) => ({
            ...order,
            status: `${order.status}`,
            currency:
              currencies.find((currency) => currency?.id === order.currencyId)
                ?.code ?? "N.A.",
          }));
          setLoader(false)
          setCurrentData(orders);
          setCurentList(orders);
          setTotalPages(data.totalPages);
          setLoading(false);
          if (data.last == true) {
            setShowButton(false);
          } else {
            setShowButton(true);
          }
        } else {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        }
      }
    );

    purchaseOrderCtl.allByPurchaserSourceBySourceTypeIdAll(
      inputValue,
      2,
      (data) => {
        if (data && !data.error) {
          let orders = data.map((order) => ({
            ...order,
            status: `${order.status}`,
            currency:
              currencies.find((currency) => currency?.id === order.currencyId)
                ?.code ?? "N.A.",
          }));
          setAllData(orders);
          setLoading(false);
          const uniquePurchasers = [
            ...new Set(data?.map((order) => order.purchaserName)),
          ];
          const options = uniquePurchasers.map((name) => ({
            value: name,
            label: name,
          }));
          setPurName(options);

          const uniqueDates = [
            ...new Set(data?.map((order) => order.createdAt)),
          ];

          const dateOptions = uniqueDates.map((date) => ({
            value: date,
            label: date,
          }));
          setPurDate(dateOptions);

          const uniqueOrder = [...new Set(data?.map((order) => order.name))];
          const orderOptions = uniqueOrder.map((ordername) => ({
            value: ordername,
            label: ordername,
          }));
          setPurOrder(orderOptions);

          const uniqueReference = [
            ...new Set(data?.map((order) => order.orderReference)),
          ];
          const refOptions = uniqueReference.map((ref) => ({
            value: ref,
            label: ref,
          }));
          setOrderRef(refOptions);

          const statusLabels = {
            1: (
              <span className="badge badge-pill text-white bg-info">
                Open
              </span>
            ),
            2: (
              <span className="badge badge-pill text-white bg-nileBlue">
                In progress
              </span>
            ),
            3: (
              <span className="badge badge-pill text-white bg-radicalRed">
                Cancelled
              </span>
            ),
            4: (
              <span className="badge badge-pill text-white bg-shamrock">
                Completed
              </span>
            ),
            5: (
              <span className="badge badge-pill text-white bg-radicalYellow">
                Processing
              </span>
            ),
            6: (
              <span className="badge badge-pill text-white bg-radicalAssColor">
                API Low Funds
              </span>
            ),
            7: (
              <span className="badge badge-pill text-white bg-radicalAssColor">
                Non API Low Funds
              </span>
            ),
            8: (
              <span className="badge badge-pill text-white bg-radicalOrange">
                Incomplete
              </span>
            ),
            9: (
              <span className="badge badge-pill text-white bg-radicalAssColor">
                Api Invoice
              </span>
            ),
            10: (
              <span className="badge badge-pill text-white bg-radicalAssColor">
                Non Api Invoice
              </span>
            ),
            11: (
              <span className="badge badge-pill text-white bg-radicalOrange">
                API Issue
              </span>
            ),
            12: (
              <span className="badge badge-pill text-white bg-radicalOrange">
                CSV Mismatched
              </span>
            ),
            14: (
              <span className="badge badge-pill text-white bg-radicalOrange">
                ERROR
              </span>
            ),
            15: (
              <span className="badge badge-pill text-white bg-radicalRed">
                Temporary out of stock
              </span>
            ),
            16: (
              <span className="badge badge-pill text-white bg-radicalYellow">
               Pending Approval
              </span> 
            ),
            17:(
              <span className="badge badge-pill text-white bg-radicalYellow">
               Imcomplete Pending Approval
              </span> 
            )
          };

          const uniqueStatusValues = [
            ...new Set(data?.map((order) => order.status)),
          ];
          const statusOptions = uniqueStatusValues.map((status) => ({
            value: status,
            label: statusLabels[status],
          }));

          setPurStatus(statusOptions);
        } else {
          Notify(alert, "danger", data.errorMessage ?? data.error);
        }
      }
    );
  } else {
    setCurrentData([]);
    setCurentList([]);
    setTotalPages(0);
    setPageNumber(0);
    setCurrentPage(1);
    setArrayIndex(0);
    setPrevButton(false);
    setShowButton(false);
    setPurName([]);
    setPurDate([]);
    setPurOrder([]);
    setPurStatus([]);
    setOrderRef([]);
  }

 }

const handleDateTwo = (e) => {
  // const today = new Date().toISOString().split('T')[0]
  // const oneMonthAgo = new Date();
  // oneMonthAgo.setMonth(oneMonthAgo.getMonth() -3); 
  // const minStartDate = oneMonthAgo.toISOString().split('T')[0];


    if (e.target.id === 'startDate') {
    
      setStartDateTwo(e.target.value)
      setEndDateTwo(null)
      endInput.current.value = '';
      endInput.current.select();
    } else {
      if (!startDateTwo) {
        Notify(alert, 'danger', 'First Select a start date');
        endInput.current.value = '';
        startInput.current.focus();
        return;
      }
     
      setEndDateTwo(e.target.value)
    }
  }

  const handleSearchDate = () =>{
    const today = new Date().toISOString().split('T')[0]

    if(startDateTwo > today && endDateTwo > today){
     Notify(alert,"danger","No Data for future dates")
     return;
    }
  if(startDateTwo && endDateTwo){
    setDateSerchLoader(true)
    if(inputValue === 1){
      purchaseOrderCtl.dateFilterSearch(startDateTwo,endDateTwo,(data)=>{
        if(data && !data.error){
          setDateSerchLoader(false)
        if(data?.length > 0){
          Notify(alert, "success", "Data successfully filtered for the selected date range.");
        }else{
          Notify(alert, "danger", "No Data Available ");
        }
          let orders = data?.map((order) => ({
            ...order,
            status: `${order.status}`,
            currency:
              currencies.find((currency) => currency?.id === order.currencyId)
                ?.code ?? "N.A.",
          }));
          setFilterActive(true)
          setCurrentData(orders)
        }else{
          setTimeout(() => {
            setDateSerchLoader(false)
          }, 1500);
          Notify(alert,"danger",data?.errorMessage ?? data?.error)
        }
      })
    }else if(inputValue > 1){
      purchaseOrderCtl.dateFilterSearchSpecific(startDateTwo,endDateTwo,inputValue,(data)=>{
        if(data && !data.error){
          setDateSerchLoader(false)
          if(data?.length > 0){
            Notify(alert, "success", "Data successfully filtered for the selected date range.");
          }else{
            Notify(alert, "danger", "No Data Available ");
          }
         let orders = data?.map((order) => ({
            ...order,
            status: `${order.status}`,
            currency:
              currencies.find((currency) => currency?.id === order.currencyId)
                ?.code ?? "N.A.",
          }));
          setFilterActive(true)
          setCurrentData(orders)
        }else{
          Notify(alert,"danger",data?.errorMessage ?? data?.error)
          setTimeout(() => {
            setDateSerchLoader(false)
          }, 1500);
        }
      })

    }else{
      setDateSerchLoader(false)
    }
    
  }else{
    Notify(alert,"danger","Please select date first")
  }
  }

const handleApproveOrderConfirm = () =>{
  purchaseOrderCtl.approveOrder(order?.name, (data)=>{
    if(data && !data?.error){
    Notify(alert,"success","Order Approved successfully")
    toggleApprove()
    }else{
      Notify(alert,"danger", data?.errorMessage ?? data?.error)
    }
  })
}

const handleApproveFileConfirm = () =>{
  purchaseOrderCtl.approveFileOrder(order?.name, (data)=>{
 if(data && !data?.error){
    Notify(alert,"success","Order Approved successfully")
    toggleApproveFile()
    }else{
      Notify(alert,"danger", data?.errorMessage ?? data?.error)
    }
  })
}
  

const handleGetUploadFile = (data) =>{
  setRowData(data)
toggleFileUpload()
}


  

  return (
    <>
     <NotificationAlert ref={alert} />
      <Row className="align-items-end my-2 g-3">
        <Col lg="6" className="me-auto">
          <FormGroup className="mb-0">
            <label for="purchaseFormBrand" className="mb-0">
              Purchaser
            </label>  
            <br />
            <Select
              id="purchaseFormBrand"
              ref={purchaser}
              options={purchasers}
              onChange={drawTable}
              isClearable={true}
            />
          </FormGroup>
        </Col>
        <Col
          xs="auto"
          className=""
        >
          <div className="search_bar">
            <label className="mb-0">Search</label>
            <br />
            <input
              type="text"
              value={globalSearch}
              onChange={(e) => handleGlobalSearch(e)}
            />
          </div>
        </Col>
        <Col xs="auto">
        {currentData?.length > 0  ? 
         <div className="d-flex justify-content-end align-items-center">
          {loader ? 
          <Button type="button" className="btn btn-primaryTwo m-0 loader_size" disabled>Refresh
          <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          style={{marginLeft:"5px"}}
                         />
          </Button>
          :
          <Button type="button" className="btn btn-primaryTwo m-0 " onClick={()=>RetriveData()}>Refresh</Button>
          }
        
        </div>
        :
        ""
        }
       
       
        </Col>
        <Col xs="auto" className="d-flex">
        {currentData?.length > 0  ? 
        <>
        <Button type="button" className="btn btn-primaryTwo m-0 " onClick={()=>setSelectShow(!selectShow)}>{ selectShow ? "Unselect" : "Select"}</Button>
        {selectedRows?.length > 0 ?
          <div
            className={`dropdown-container custom_dropdownx ms-2 ${
              isOpenTwo ?"dropdown-open" : ""
            }`}
            ref={dropdownRef}
          >
            <button
              className="dropdown-toggle click-dropdown border-0 bg-transparent"
              onClick={() => {
                toggleDropdownThree();
              }}
            >
              <div className="actionBtn">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>
            <div
              className={`dropdown-menu ${
                isOpenTwo ? "dropdown-active" : ""
              }`}
            >
              <ul>
               <li>
                    <span
                      className="d-inline-block py-2"
                      onClick={() => cancelOrderAll()}
                    >
                      Cancel order
                    </span>
                  </li>
                  <li>
                    <span
                      className="d-inline-block py-2"
                      onClick={() => retryOrderAll()}
                    >
                      Retry order
                    </span>
                  </li>
                </ul>
            </div>
          </div>
          :""
           }
           </>
        :
        ""}
      
        </Col>
        {/* <Col xs="auto" className="mt-0" style={{marginBottom:"7px"}}>
         
                      </Col> */}
                      </Row>
    {
     currentData?.length > 0 ?
   <Row className="my-2 g-3">
       
       <Col xs="auto" style={{marginTop:"33px"}}>
       <Button type="button" className="btn btn-primaryTwo" onClick={openModel} title="Download Historical " >
        <i className='bx bxs-download me-1 py-0' style={{ fontSize: '14px' }} ></i> Download</Button>
       </Col>
       <Col xl="4" className="ms-auto">
       
       </Col>
       <Col xs="auto">
       
       <FormGroup>
					<Label for='startDate' >Start date</Label>
					<Input type='date' id='startDate' pattern='\d{4}-\d{2}-\d{2}'
           innerRef={startInput} 
           onChange={handleDateTwo}
           />
				</FormGroup>
       </Col>
       <Col xs="auto">
       <FormGroup>
        <Label for='endDate'>End date</Label>
        <Input type='date' id='endDate' pattern='\d{4}-\d{2}-\d{2}' 
        innerRef={endInput}
         onChange={handleDateTwo} 
         min={startDateTwo ? startDateTwo : ''}
         />
        </FormGroup>
       </Col>
       <Col xs="auto" style={{marginTop:"32px"}}>
       {startDateTwo?.length > 0  ||  endDateTwo?.length > 0?
         <button className='btn btn-primaryTwo' onClick={resetSearch} style={{ height: '39px', display: 'flex', alignItems: 'center' }} > 
								Reset
									</button>
                  :""}
       </Col>
       <Col xs="auto" style={{marginTop:"32px"}}>
       <button className='btn btn-primaryTwo' onClick={handleSearchDate} style={{ height: '39px', display: 'flex', alignItems: 'center' }} disabled={dateSearchLoader}>{!dateSearchLoader && <i className='bx bx-search me-1 py-0'></i>}
								<span className='d-none d-xl-inline'>{!dateSearchLoader && "Search"}{
									dateSearchLoader &&
									<Spinner
									as="span"
									animation="border"
									size="sm"
									role="status"
									aria-hidden="true"
									style={{marginLeft:"5px"}}
									/>

									}</span></button>
       </Col>
      
      </Row>
      :
      ''
    }
      
     
      <div className="card my-4 table-widget">
        <div className="card-body shadow-lg" style={{ borderRadius: "10px" }}>
          <div className="table-responsive table_scroll">
            <table className="table table-borderless">
              <thead className="fixed_th">
                <tr>
                {selectShow && (
                <th className=""> 
                  <p>Select All</p>
                  <input type="checkbox" checked={selectedRows.length === updateCurrentData.length} onChange={(e) => handleSelectAll(e)} />
                </th>
              )}   
                  <th>
                    Purchaser's Name <i className="bi bi-sort-down"></i>
                    <div style={{ marginTop: "4px" }}>
                      <FormGroup>
                        <Select
                          id="purchaseFormBrand"
                          options={purName}
                          isMulti={true}
                          onChange={nameFilter}
                          isClearable={true}
                        />
                      </FormGroup>
                    </div>
                  </th>
                  <th>
                    Date <i className="bi bi-sort-down"></i>
                    <FormGroup style={{ marginTop: "24px" }}>
                      <Select
                        id="purchaseFormBrand"
                        options={purDate}
                        isMulti={true}
                        onChange={dateFilter}
                        isClearable={true}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    Order<i className="bi bi-sort-down"></i>
                    <FormGroup style={{ marginTop: "24px" }}>
                      <Select
                        id="purchaseFormBrand"
                        options={purOrder}
                        isMulti={true}
                        onChange={orderFilter}
                        isClearable={true}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    Order Reference<i className="bi bi-sort-down"></i>
                    <FormGroup style={{ marginTop: "4px" }}>
                      <Select
                        id="purchaseFormBrand"
                        options={orderRef}
                        isMulti={true}
                        onChange={refFilter}
                        isClearable={true}
                      />
                    </FormGroup>
                  </th>
                  <th>
                    Currency <i className="bi bi-sort-down"></i>
                    <div style={{ marginTop: "74px" }}></div>
                  </th>
                  <th>
                    Total Gift Card <i className="bi bi-sort-down"></i>
                    <div style={{ marginTop: "58px" }}></div>
                  </th>
                  <th>
                    Total Amount <i className="bi bi-sort-down"></i>
                    <div style={{ marginTop: "58px" }}></div>
                  </th>
                  <th>
                    Qty<i className="bi bi-sort-down"></i>
                    <div style={{ marginTop: "74px" }}></div>
                  </th>
                  <th style={{ width: "124px" }}>
                    Status<i className="bi bi-sort-down"></i>
                    <FormGroup style={{ marginTop: "24px" }}>
                      <Select
                        id="purchaseFormBrand"
                        options={purStatus}
                        isMulti={true}
                        onChange={statusFilter}
                        isClearable={true}
                      />
                    </FormGroup>
                  </th>
                  <th className="text-center">
                    Action<i className="bi bi-sort-down"></i>
                    <div style={{ marginTop: "74px" }}></div>
                  </th>
                  {/* <th>dropdown</th> */}
                </tr>
              </thead>
              <tbody>
                {updateCurrentData?.length > 0 ? (
                  updateCurrentData?.map((data, index) => (
                    <React.Fragment key={index}>
                      <tr key={index} onClick={()=>openDrawerRow(data)} style={{ cursor: "pointer" }} title="Click the row to view details">
                       {selectShow && (
                        <td onClick={(e) => e.stopPropagation()}>
                          <input type="checkbox"  checked={selectedRows.includes(data.id)} onChange={(e) => handleChangeCheck(data, e)} />
                        </td>
                      )}
                        <td>{data?.purchaserName}</td>
                        <td>{data?.createdAt}</td>
                        <td>{data?.name}</td>
                        <td>{data?.orderReference}</td>
                        <td>{data?.currency}</td>
                        <td>
                          $
                          {data?.subtotal?.toFixed(2).length > 5
                            ? data.subtotal
                                .toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : data?.subtotal?.toFixed(2)}
                        </td>
                        <td>
                          $
                          {data?.totalAmount?.toFixed(2).length > 5
                            ? data.totalAmount
                                .toFixed(2)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : data?.totalAmount?.toFixed(2)}
                        </td>
                        <td>
                          {data?.totalQuantity
                            ? data.totalQuantity % 1 === 0
                              ? data.totalQuantity.toLocaleString()
                              : data.totalQuantity.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                            : ""}
                        </td>
                        <td>
                          {data?.status == 1 ? (
                            <span className="badge badge-pill text-white bg-info">
                              Open
                            </span>
                          ) : data?.status == 2 ? (
                            <span className="badge badge-pill text-white bg-nileBlue">
                              In progress
                            </span>
                          ) : data?.status == 3 ? (
                            <span className="badge badge-pill text-white bg-radicalRed">
                              Cancelled
                            </span>
                          ) : data?.status == 4 ? (
                            <span className="badge badge-pill text-white bg-shamrock">
                              Completed
                            </span>
                          ) : data?.status == 5 ? (
                            <span className="badge badge-pill text-white bg-radicalYellow">
                              Processing
                            </span>
                          ) : data?.status == 6 ? (
                            <span className="badge badge-pill text-white bg-radicalAssColor">
                              API Low Funds
                            </span>
                          ) : data?.status == 7 ? (
                            <span className="badge badge-pill text-white bg-radicalAssColor">
                              Non API Low Funds
                            </span>
                          ) : data?.status == 8 ? (
                            <span className="badge badge-pill text-white bg-radicalOrange">
                              Incomplete
                            </span>
                          ) : data?.status == 9 ? (
                            <span className="badge badge-pill text-white bg-radicalAssColor">
                              Api Invoice
                            </span>
                          ) : data?.status == 10 ? (
                            <span className="badge badge-pill text-white bg-radicalAssColor">
                              Non Api Invoice
                            </span>
                          ) : data?.status == 11 ? (
                            <span className="badge badge-pill text-white bg-radicalOrange">
                              API Issue
                            </span>
                          ) : data?.status == 12 ? (
                            <span className="badge badge-pill text-white bg-radicalOrange">
                              CSV Mismatched
                            </span>
                          ) : data?.status == 13 ? (
                            <span className="badge badge-pill text-white bg-radicalOrange">
                              Pending
                            </span>
                          ) : data.status == 15 ? (
                            <span className="badge badge-pill text-white bg-radicalRed">
                              Temporary out of stock
                            </span>
                          ) : 
                            data?.status == 14 ? (
                              <span className="badge badge-pill text-white bg-radicalRed">
                                ERROR
                              </span>
                            ):
                            data?.status == 16 ? (
                            <span className="badge badge-pill text-white bg-radicalYellow">
                              Pending Approval
                            </span>
                            ):
                            data?.status == 17 &&(
                            <span className="badge badge-pill text-white bg-radicalYellow">
                             Imcomplete Pending Approval
                            </span>
                            )
                              }
                        </td>
                        
                        <td  onClick={(e) => e.stopPropagation()}>
                          <div
                            className={`dropdown-container custom_dropdownx ${
                              isOpen == data?.id ? "dropdown-open" : ""
                            }`}
                            ref={dropdownRef}
                          >
                            <button
                              className="dropdown-toggle click-dropdown border-0 bg-transparent"
                              onClick={() => {
                                toggleDropdown(data?.id);
                              }}
                            >
                              <div className="actionBtn">
                                <span></span>
                                <span></span>
                                <span></span>
                              </div>
                            </button>
                            <div
                              className={`dropdown-menu ${
                                isOpen ? "dropdown-active" : ""
                              }`}
                            >
                              <ul>
                                {
                                  data?.status != 16 && data?.status != 17  && (
                                 <li>
                                  <span
                                    className="d-inline-block py-2"
                                    onClick={() => prepareDetails(data)}
                                  >
                                    Order Details
                                  </span>
                                </li>
                                  )
                                }
                                
                                {
                                  data?.status != 16 &&  data?.status != 17 && (
                                    <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => prepareBatch(data)}
                                    >
                                      Order Batch
                                    </span>
                                  </li>
                                  )
                                }
                               

                                {data?.status == 5 && (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => uploadFile(data)}
                                    >
                                      Upload file non-API
                                    </span>
                                  </li>
                                )}
                                {data?.status == 4 && (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => downloadOrder(data)}
                                    >
                                      Download Order
                                    </span>
                                  </li>
                                )}
                                {data?.status == 1 || data?.status == 8 ? (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => RepeatFunction(data)}
                                    >
                                      Download file non-API
                                    </span>
                                  </li>
                                ) : null}
                                {data?.status == 4? (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => ReplaceFunction(data)}
                                    >
                                      Replace Order
                                    </span>
                                  </li>
                                ) : null}
                                {data?.status == 8 && (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() =>
                                        downloadIncompleteOrderfile(data)
                                      }
                                    >
                                      Download incomplete file
                                    </span>
                                  </li>
                                )}
                                {(data?.status == 5 ||
                                  data?.status == 1 ||
                                  data?.status == 9 ||
                                  data?.status == 10 ||
                                  data?.status == 6 ||
                                  data?.status == 7 ||
                                  data?.status == 8 ||
                                  data?.status == 11 ||
                                  data?.status == 2) && (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => cancelOrder(data)}
                                    >
                                      Cancel order
                                    </span>
                                  </li>
                                )}
                                {(data?.status == 8 || data?.status == 11) && (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => retryOrder(data)}
                                    >
                                      Retry order
                                    </span>
                                  </li>
                                )}
                                {data?.status == 9 && (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => releaseOrder(data)}
                                    >
                                      Release order
                                    </span>
                                  </li>
                                )}
                                {data?.status == 8 && (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => modifyOrder(data)}
                                    >
                                      Modify order
                                    </span>
                                  </li>
                                )}
                                {data?.status == 10 && (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => releaseNonApiOrder(data)}
                                    >
                                      Release order
                                    </span>
                                  </li>
                                )}

                                {data?.status == 5 && (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => modifyNRTOrder(data)}
                                    >
                                      Modify Order
                                    </span>
                                  </li>
                                )}

                           {data?.status == 4 && (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => resetPassWord(data)}
                                    >
                                      Reset Password
                                    </span>
                                  </li>
                                )}
                                  {(data?.status == 8 || data?.status == 11 ) && (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => failedOrder(data)}
                                    >
                                    Restore Orders
                                    </span>
                                  </li>
                                )}
                                {(data?.status == 11 || data?.status == 8 ||  data?.status == 15) && (
                                  <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => ApiIssueDeatils(data)}
                                    >
                                    Api Issue Details
                                    </span>
                                  </li>
                                )}
                                {
                                  data?.status == 16 && (
                                    <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => approveOrder(data)}
                                    >
                                    Approve
                                    </span>
                                  </li>
                                  )
                                }
                                {
                                  data?.status == 16 && (
                                 <li>
                                  <span
                                    className="d-inline-block py-2"
                                    onClick={() => cancelOrder(data)}
                                  >
                                   Reject
                                  </span>
                                </li>
                                  )
                                  
                                }
                                {
                                  data?.status == 17 && (
                                    <li>
                                    <span
                                      className="d-inline-block py-2"
                                      onClick={() => approveFileOrder(data)}
                                    >
                                    Approve
                                    </span>
                                  </li>
                                  )
                                }
                                {
                                  data?.status == 17 && (
                                 <li>
                                  <span
                                    className="d-inline-block py-2"
                                    onClick={() =>handleGetUploadFile(data)}
                                  >
                                   Get file 
                                  </span>
                                </li>
                                  )
                                  
                                }
                                 {
                                  data?.status == 17 && (
                                 <li>
                                  <span
                                    className="d-inline-block py-2"
                                    onClick={() => cancelOrder(data)}
                                  >
                                   Cancel
                                  </span>
                                </li>
                                  )
                                  
                                }
                              </ul>
                            </div>
                          </div>
                        </td>
                      </tr>
                       {openDrawerId === data?.id && (
                        <tr>
                          <td colSpan="12">
                            <table className="table nested_table">
                              <thead>
                                <tr>
                                  <th className="border-0">Brand</th>
                                  <th className="border-0">Card Type</th>
                                  <th className="border-0">SKU</th>
                                  <th className="border-0">Currency</th>
                                  <th className="border-0">Fee</th>
                                  <th className="border-0">Discount</th>
                                  <th className="border-0">Qty</th>
                                  <th className="border-0">Value</th>
                                  <th className="border-0">Subtotal</th>
                                  
                                  <th className="border-0">Profit</th>
                                  <th className="border-0">Margin Percentage</th>
                                </tr>
                              </thead>
                              <tbody>
                                {nestedData?.length > 0 ? (
            nestedData.map((nestedRow, nestedIndex) => {
              const card = cardTypes.find(card => card.id === nestedRow.cardTypeId);
             return (
                <tr key={nestedIndex}>
                  <td>{nestedRow?.brandName}</td>
                  <td>{nestedRow?.cardTypeName}</td>
                  <td>{card?.sku || "N/A"}</td> 
                  <td>{nestedRow?.currency}</td>
                  <td>${nestedRow?.fee.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                  <td>{nestedRow?.discount.toFixed(2)}%</td>
                  <td>{nestedRow?.quantity}</td>
                  <td>${nestedRow?.amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                  <td>${nestedRow?.total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                  
                  <td>
                    {nestedRow?.profit < 0
                      ? `-$${Math.abs(nestedRow?.profit).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                      : `$${nestedRow?.profit.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
                  </td>
                  <td>{nestedRow?.marginPercentage.toFixed(2)}%</td>
                 
                </tr>
              );
            })
          ): loaderTwo ? (
                                  <tr>
                                  <td colSpan="12" style={{ textAlign: "center" }}>
                                    <div className="spinner-border text-muted text-center"></div>
                                  </td>
                                  </tr>
                                ) : (
                                  <tr>
                                  <td colSpan="9" className="text-center">No order details found</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      )} 
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan={9}>{"No orders found !"}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="d-flex" style={{ flexWrap: "wrap" }}>
            <div style={{ marginTop: "4px" }}>
              {showPrevButton && (
                <Button
                  onClick={handleHide}
                  style={{
                    backgroundColor: "#007bff",
                    fontSize: "13px",
                    padding: "4px 15px",
                  }}
                  className="pagination_button"
                >
                  Show Previous
                </Button>
              )}
            </div>
            {filterActive === false ? (
              <TablePagination
                totalItems={currentData?.length}
                pageNumber={currentPage}
                onPageChange={handlePageChange}
                indexUpdate={arrayIndex}
                pageSizeNew={pageSizeNew}
              />
            ) : (
              <CustomPagination
                totalItems={currentData?.length}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                pageSizeNew={pageSizeNew}
              />
            )}
            <div style={{ marginTop: "4px" }}>
              {showButton && currentData?.length == 100 && (
                <Button
                  onClick={handleShow}
                  style={{
                    backgroundColor: "#007bff",
                    fontSize: "13px",
                    padding: "4px 15px",
                  }}
                  className="pagination_button"
                >
                  Show More
                </Button>
              )}
            </div>
            <div style={{ position: "relative", display: "inline-block",marginTop:"4px" }}  ref={dropdownRefTwo}>
             {currentData?.length >10 && (    
      <button
        onClick={toggleDropdownTwo}
        style={{
          backgroundColor: "#007bff",
          fontSize: "13px",
          padding: "8px 9px",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Rows Per Page: {rowsPerPage}
      </button>
            )} 
      {showDropdown && (
        <div
          style={{
            position: "absolute",
            bottom: "115%",
            left: 0,
            backgroundColor: "#ffffff",
            boxShadow: "2px 2px 4px 4px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
            borderRadius: "4px",
            padding: "5px 0",
            minWidth: "150px",
          }}
        >
          <div
            onClick={() => handleOptionClick(10)}
            style={{
              padding: "8px 12px",
              cursor: "pointer",
              fontSize: "13px",
              color: "#333",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
          >
            10
          </div>
          <div
            onClick={() => handleOptionClick(20)}
            style={{
              padding: "8px 12px",
              cursor: "pointer",
              fontSize: "13px",
              color: "#333",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
          >
            20
          </div>
          <div
            onClick={() => handleOptionClick(50)}
            style={{
              padding: "8px 12px",
              cursor: "pointer",
              fontSize: "13px",
              color: "#333",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
          >
            50
          </div>
          <div
            onClick={() => handleOptionClick(100)}
            style={{
              padding: "8px 12px",
              cursor: "pointer",
              fontSize: "13px",
              color: "#333",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
          >
            100
          </div>
        </div>
      )}
    </div>
          </div>
        </div>
      </div>
      <ModalUploadCSV
        saveCsv={setSaveCsv}
        modal={modalUploadCSV}
        toggle={toggleModalCSV}
        uploadJson={uploadJson}
        token={token}
        confrimButton={confrimButton}
      />
      <SwipeableDrawer
        anchor="right"
        open={openDrawer}
        onClose={toggleDrawer}
        onOpen={toggleDrawer}
      >
        <div style={{ width: "60vw" }}>
          <OrderDetails
            order={orderDetail}
            token={token}
            brands={brands.result}
            cardTypes={cardTypes}
            name={purchaserName}
            OrderName={checkOrder}
            show={show}
            openDrawer={openDrawer}
          />
        </div>
      </SwipeableDrawer>
      <SwipeableDrawer
        anchor="right"
        open={openModifyDrawer}
        onClose={() => handleToggleDrawer(false)}
        onOpen={() => handleToggleDrawer(true)}
      >
        <div style={{ width: "60vw" }}>
          <OrderModifyDetails
            order={orderDetail}
            token={token}
            brands={brands.result}
            cardTypes={cardTypes}
            name={purchaserName}
            show={showTwo}
            toggleModifyDrawer={openModifyDrawer}
            toggleDrawer={handleToggleDrawer}
            showApplyButton={showApplyButton}
            setShowApplyButton={setShowApplyButton}
           
          />
        </div>
      </SwipeableDrawer>
      <SwipeableDrawer
        anchor="right"
        open={openNRTModifyDrawer}
        onClose={toggleModifyNRTDrawer}
        onOpen={toggleModifyNRTDrawer}
      >
        <div style={{ width: "60vw" }}>
          <OrderNRTModify
            order={orderDetail}
            token={token}
            brands={brands.result}
            cardTypes={cardTypes}
            name={purchaserName}
            show={showThree}
            toggleModifyDrawer={openNRTModifyDrawer}
            setToggleModifyOrder={setOpenNRTModifyDrawer}
         
          />
        </div>
      </SwipeableDrawer>
      <SwipeableDrawer
        anchor="right"
        open={openBatchDrwer}
        onClose={toogleBatchDrawer}
        onOpen={toogleBatchDrawer}
      >
        <div style={{ width: "60vw" }}>
          <OrderBatch
            order={batchDetails}
            token={token}
            brands={brands.result}
            cardTypes={cardTypes}
            openDrawer={openBatchDrwer}
          />
        </div>
      </SwipeableDrawer>

      <Modal
        isOpen={uploadCSV}
        toggle={toggleUpload}
        backdrop="static"
        centered={true}
        size="xl"
      >
        <ModalHeader toggle={toggleUpload} className="custom_header_colourTwo">
          Process Non-realTime order In RealTime
        </ModalHeader>
        <Form>
          <ModalBody>
            <div className={modalCSVcss.container}>
              <div className="text">
                <p>Please select a file of type CSV and press send.</p>
              </div>
              <label htmlFor="file" className={modalCSVcss.formContainer}>
                <UploadIcon />
                <span>File Upload CSV</span>
                <input
                  type="file"
                  name=""
                  id="file"
                  className={modalCSVcss.dn}
                  onChange={handleFileChange}
                  //   ref={file}
                  accept=".csv"
                />
              </label>

              {fileCsv?.name && (
                <div className={modalCSVcss.fileSelected}>
                  <p>
                    {fileCsv.name}{" "}
                    <span className="arrow">
                      <img src={okIMG} alt="" />
                    </span>
                  </p>
                </div>
              )}
            </div>
            <p
              className="dbuttonc"
              style={{
                color: "#2665F2",
                fontWeight: "900",
                cursor: "pointer",
                fontSize: "18px",
              }}
              
              onClick={() => {
                downloadCSVFile();
              }}
            >
              Download Template
            </p>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" onClick={toggleUpload}>
              Cancel
            </Button>{" "}
            <Button type="button" className="btn btn-primaryTwo" onClick={toggleConfimCsv}>
              Save
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal
        isOpen={retryModal}
        toggle={toggleRetry}
        backdrop="static"
        centered={true}
        size="md"
      >
        <ModalHeader toggle={toggleRetry} className="custom_header_colourTwo">
          Retry Order
        </ModalHeader>
        <ModalBody>
          <div>
            <p style={{ fontSize: "22px", fontWeight: "600" }}>
              Do You Want To Retry{" "}
            </p>
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-between">
          <Button type="button" color="secondary" onClick={toggleRetry}>
            Cancel
          </Button>{" "}
          <Button type="submit" className="btn btn-primaryTwo" onClick={confirmRetry}>
            Procced
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={retryAll}
        toggle={toggleRetryAll}
        backdrop="static"
        centered={true}
        size="md"
      >
        <ModalHeader toggle={toggleRetryAll} className="custom_header_colourTwo">
          Retry Selected Order
        </ModalHeader>
        <ModalBody>
          <div>
            <p style={{ fontSize: "22px", fontWeight: "600" }}>
              Do You Want To Retry Selected Order
            </p>
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-between">
          <Button type="button" color="secondary" onClick={toggleRetryAll}>
            Cancel
          </Button>{" "}
          <Button type="submit" className="btn btn-primaryTwo" onClick={confirmAllRetry} disabled={confirmAllLoader}>
            Procced {
              confirmAllLoader && 
              <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              style={{marginLeft:"5px"}}
                             />
            }
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={releaseOpen}
        toggle={toggleRelease}
        backdrop="static"
        centered
      >
        <ModalHeader className="bg-warning" toggle={toggleRelease}>
          Release Order
        </ModalHeader>
        <ModalBody>
          <p style={{ fontSize: "22px", fontWeight: "600" }}>
            Do you want to release the order?
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleRelease}>
            Close
          </Button>
          <Button color="primary" onClick={confirmRelease}>
            Confirm
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={cancelOdr}
        toggle={toggleCancel}
        backdrop="static"
        centered
      >
        <ModalHeader className="custom_header_colourTwo" toggle={toggleCancel}>
          Cancel Order
        </ModalHeader>
        <ModalBody>
          <p style={{ fontSize: "22px", fontWeight: "600" }}>
            Do you want to cancel the order?
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleCancel}>
            Close
          </Button>
          <Button className="btn btn-primaryTwo" onClick={confirmCancel}>
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={cancelOrderall}
        toggle={toggleCancelAll}
        backdrop="static"
        centered
      >
        <ModalHeader className="custom_header_colourTwo" toggle={toggleCancelAll}>
          Cancel ALL Order
        </ModalHeader>
        <ModalBody>
          <p style={{ fontSize: "22px", fontWeight: "600" }}>
            Do you want to cancel all selected order?
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleCancelAll}>
            Close
          </Button>
          <Button className="btn btn-primaryTwo" onClick={confirmCancelAll} disabled={cancelAllLoader}>
            Confirm {cancelAllLoader
            &&
            <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            style={{marginLeft:"5px"}}
                />

            }
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
        <ModalHeader className="bg-warning" toggle={toggleWarning}>
          Access Denied
        </ModalHeader>
        <ModalBody>
          <p className="card-just-text">
            You do not have access to perform this action
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleWarning}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={downOrder}
        toggle={toggleDownload}
        backdrop="static"
        centered
      >
        <ModalHeader className="custom_header_colourTwo" toggle={toggleDownload}>
          Download Order
        </ModalHeader>
        <ModalBody>
          <p style={{ fontSize: "22px", fontWeight: "600" }}>
            Do you want to download the order?
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleDownload}>
            Close
          </Button>
          <Button className="btn btn-primaryTwo" onClick={dowloadOrderConfirm}>
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
      
      <Modal isOpen={confrimCsv} toggle={toggleConfimCsv} backdrop="static" centered>
				<ModalHeader className="bg-warning" toggle={toggleConfimCsv}>Upload Csv Confirm</ModalHeader>
				<ModalBody>
        <NotificationAlert ref={alert} />
					<p style={{fontSize:"22px",fontWeight:"600"}}>
						Do you want to Upload the CSV?
					</p>
				</ModalBody>
				<ModalFooter>
					<button className="btn btn-secondary" onClick={toggleConfimCsv}>Close</button>
					<button className="btn btn-primaryTwo" type="submit" onClick={handleFileUpload}>Confirm</button>
				</ModalFooter>
			</Modal>

      <Modal isOpen={confirmFileCsv} toggle={toggleConfimCsvFile} backdrop="static" centered>
				<ModalHeader className="bg-warning" toggle={toggleConfimCsvFile}>Upload Csv Confirm</ModalHeader>
				<ModalBody>
        <NotificationAlert ref={alert} />
					<p style={{fontSize:"22px",fontWeight:"600"}}>
						Do you want to Upload the CSV?
					</p>
				</ModalBody>
				<ModalFooter>
					<button className="btn btn-secondary" onClick={toggleConfimCsvFile}>Close</button>
					<button className="btn btn-primaryTwo" type="submit" onClick={handleFileNewUpload}>Confirm</button>
				</ModalFooter>
			</Modal>
      <Modal isOpen={confrimCsvTwo} toggle={toggleConfimCsvTwo} backdrop="static" centered>
				<ModalHeader className="bg-warning" toggle={toggleConfimCsvTwo}>Upload Csv Confirm</ModalHeader>
				<ModalBody>
        
         <p style={{fontSize:"22px",fontWeight:"600"}}>
						Do you want to Upload the CSV?
					</p>
				</ModalBody>
				<ModalFooter>
					<button className="btn btn-secondary" onClick={toggleConfimCsvTwo}>Close</button>
					<button className="btn btn-primaryTwo" type="submit" onClick={handleFileUploadTwo}>Confirm</button>
				</ModalFooter>
			</Modal>
      <Modal
        isOpen={replaceUpload}
        toggle={toggleReplaceUpload}
        backdrop="static"
        centered={true}
        size="xl"
      >
        <ModalHeader toggle={handleCancelReplaceUpload} className="custom_header_colourTwo">
          Process Non-realTime order In RealTime
        </ModalHeader>
        <Form>
          <ModalBody>
             <NotificationAlert ref={alert} />
            <div className={modalCSVcss.container}>
              <div className="text">
                <p>Please select a file of type CSV and press send.</p>
              </div>
              <label htmlFor="file" className={modalCSVcss.formContainer}>
                <UploadIcon />
                <span>File Upload CSV</span>
                <input
                  type="file"
                  name=""
                  id="file"
                  className={modalCSVcss.dn}
                  onChange={handleFileChangeReplace}
                  //   ref={file}
                  accept=".csv"
                />
              </label>

              {fileCsvTwo?.name && (
                <div className={modalCSVcss.fileSelected}>
                  <p>
                    {fileCsvTwo.name}{" "}
                    <span className="arrow">
                      <img src={okIMG} alt="" />
                    </span>
                  </p>
                </div>
              )}
            </div>
            <p
              className="dbuttonc"
              style={{
                color: "#2665F2",
                fontWeight: "900",
                cursor: "pointer",
                fontSize: "18px",
              }}
      
              onClick={() => {
                downloadCSVFileTwo();
              }}
            >
              Download Template
            </p>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" onClick={handleCancelReplaceUpload}>
              Cancel
            </Button>{" "}
            <Button type="button" className="btn btn-primaryTwo" onClick={toggleConfimCsvTwo}>
              Save
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
      <Modal isOpen={password} toggle={toggleResetPassword} backdrop="static" centered>
				<ModalHeader className="custom_header_colourTwo" toggle={toggleResetPassword}>Reset Password Confirm</ModalHeader>
				<ModalBody>
        
         <p style={{fontSize:"22px",fontWeight:"600"}}>
						Do you want to reset your Download file password?
					</p>
				</ModalBody>
				<ModalFooter>
					<button className="btn btn-secondary" onClick={toggleResetPassword}>Close</button>
					<button className="btn btn-primaryTwo" type="submit" onClick={handleResetPassword}>Confirm</button>
				</ModalFooter>
			</Modal>
      <Modal isOpen={restoreModal} toggle={toggleRestoreOrder} backdrop="static" centered>
				<ModalHeader className="custom_header_colourTwo" toggle={toggleRestoreOrder}>Restore Order Confirm</ModalHeader>
				<ModalBody>
        
         <p style={{fontSize:"22px",fontWeight:"600"}}>
						Do you want to restore your failed order?
					</p>
				</ModalBody>
				<ModalFooter>
					<button className="btn btn-secondary" onClick={toggleRestoreOrder}>Close</button>
					<button className="btn btn-primaryTwo" type="submit" onClick={handleRestoreOrder} disabled={restoreLoader}>{!restoreLoader && "Confirm"}{
            restoreLoader && 
            <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            style={{marginLeft:"5px"}}
                           />
            }</button>
				</ModalFooter>
			</Modal>
      
      <Modal
        isOpen={apiIssueModal}
        toggle={toggleIssueDeatils}
        backdrop="static"
        centered={true}
        size="lg"
      >
        <ModalHeader toggle={toggleIssueDeatils} className="custom_header_colourTwo">
          Api Issue Failure Information
        </ModalHeader>
        <ModalBody>
       
          <div className="table-container">
      <table className="responsive-table">
        <thead>
          <tr>
          <th>Purchase Order Name</th>
            <th>Supplier Name</th>
            <th>Brand Name</th>
            <th>Supplier Order Number</th>
            <th>Error Message or Code</th>
            <th>Timestamp of Failure</th>
            
          </tr>
        </thead>
        <tbody>
        {apiIssueLoader ? (
            <tr>
              <td colSpan="4" style={{ textAlign: "center" }}>
                <div className="spinner-border text-muted text-center"></div>
              </td>
            </tr>
          ) : apidetails.length > 0 ? (
            apidetails.map((data, index) => (
              <tr key={index}>
                <td>{data?.purchaseOrderName}</td>
                <td>{data?.supplier}</td>
                <td>{data?.brand}</td>
                <td>{data?.supplierOrderNumber ? data?.supplierOrderNumber : "Not Available"}</td>
                <td>
                  {data?.errorMessage?.length > 10 ? (
                    <>
                      <a
                        className=""
                        style={{ textDecoration: "none", color: "blue", cursor: "pointer", whiteSpace:"nowrap" }}
                        onClick={() => setShowModal(true)}
                      >
                        View Error Message
                      </a>
                    </>
                  ) : (
                    data?.errorMessage
                  )}
                </td>
                <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered size="lg">
                  <ModalHeader toggle={() => setShowModal(false)}>Error Message</ModalHeader>
                  <ModalBody style={{maxHeight:"80vh", overflow:"auto"}}>
                  {data?.errorMessage}
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={() => setShowModal(false)}>
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>

                <td>{data?.timestamp}</td>
                
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No details found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
          
        </ModalBody>
        <ModalFooter className="justify-content-between">
          <Button type="button" color="secondary" onClick={toggleIssueDeatils}>
            Cancel
          </Button>{" "}
       
        </ModalFooter>
      </Modal>

      <Modal isOpen={approveModal} toggle={toggleApprove} backdrop="static" centered>
				<ModalHeader className="custom_header_colourTwo" toggle={toggleApprove}>Approve Order Confirm</ModalHeader>
				<ModalBody>
        
         <p style={{fontSize:"22px",fontWeight:"600"}}>
						Do you want to approve your pending order?
					</p>
				</ModalBody>
				<ModalFooter>
					<button className="btn btn-secondary" onClick={toggleApprove}>Close</button>
					<button className="btn btn-primaryTwo" type="submit" onClick={handleApproveOrderConfirm}>Confirm</button>
				</ModalFooter>
			</Modal>

     <Modal isOpen={approveFile} toggle={toggleApproveFile} backdrop="static" centered>
				<ModalHeader className="custom_header_colourTwo" toggle={toggleApproveFile}>Approve The Pending Order Confirm</ModalHeader>
				<ModalBody>
        
         <p style={{fontSize:"22px",fontWeight:"600"}}>
						Do you want to approve your pending order?
					</p>
				</ModalBody>
				<ModalFooter>
					<button className="btn btn-secondary" onClick={toggleApproveFile}>Close</button>
					<button className="btn btn-primaryTwo" type="submit" onClick={handleApproveFileConfirm}>Confirm</button>
				</ModalFooter>
			</Modal>


      <Modal isOpen={isDownloadModalOpen} toggle={openModel} backdrop="static" size="md">
          <ModalHeader className="custom_header_colourTwo " toggle={openModel}>Select Date For Historical Report</ModalHeader>
          <ModalBody>
            <Row className="">
      
            <> 
            <NotificationAlert ref={alert} />
            <Col md={6}>
                    <FormGroup>
                      <Label for='startDate' >Start date</Label>
                      <Input type='date' id='startDate' pattern='\d{4}-\d{2}-\d{2}'  style={{ height: '40px' }}  innerRef={startDateInput} onChange={handleDate} />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for='endDate'>End date</Label>
                      <Input type='date' id='endDate' pattern='\d{4}-\d{2}-\d{2}' innerRef={endDateInput} onChange={handleDate} min={startDate ? startDate : ''}
                      style={{ height: '40px' }}/>
                    </FormGroup>
                  </Col>
                  </>
          
            </Row>
            <Row className='d-flex align-items-center justify-content-center'>
              <Col md="6"  className="mb-3 mb-md-0">
              {
                buttonLoading ? 
                <Button className='btn btn-primaryTwo' disabled  >
                  
                  Send Sales Report
                  <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                              style={{marginLeft:"5px"}}
                            />
                </Button>
                :
                <Button className='btn btn-primaryTwo'  onClick={handleDownloadFile} >
                 Send Sales Report
                </Button>
              }
                
              </Col>
              
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={openModel}>Close</Button>{' '}
          </ModalFooter>
        </Modal>

           <Modal isOpen={confirmReport} toggle={toggleconfirmSalesReport} centered>
            <ModalHeader toggle={toggleconfirmSalesReport} className="custom_header_colourTwo d-flex align-items-center justify-content-between bg-success">Confirmation</ModalHeader>
            <ModalBody>
             The sales report will be sent to your email in a few minutes.
            </ModalBody>
            <ModalFooter>
            <Button  type="button"  color="secondary" onClick={toggleconfirmSalesReport}>Cancel</Button>
            </ModalFooter>
        </Modal>

        <Modal
            isOpen={uploadGetCsv}
            toggle={toggleFileUpload}
            backdrop="static"
            centered={true}
            size="xl"
          >
            <ModalHeader toggle={toggleFileUpload} className="custom_header_colourTwo">
              Get file for incomplete pending orders
            </ModalHeader>
            <Form>
              <ModalBody>
                <div className={modalCSVcss.container}>
                  <div className="text">
                    <p>Please select a file of type CSV and press send.</p>
                  </div>
                  <label htmlFor="file" className={modalCSVcss.formContainer}>
                    <UploadIcon />
                    <span>File Upload CSV</span>
                    <input
                      type="file"
                      id="file"
                      className={modalCSVcss.dn}
                      onChange={handleFileChangeNew}
                      accept=".csv"
                    />
                  </label>

                  {fileCsvNew?.name && (
                    <div className={modalCSVcss.fileSelected}>
                      <p>
                        {fileCsvNew?.name}{" "}
                        <span className="arrow">
                          <img src={okIMG} alt="" />
                        </span>
                      </p>
                    </div>
                  )}
                </div>
                <p
                  className="dbuttonc"
                  style={{
                    color: "#2665F2",
                    fontWeight: "900",
                    cursor: "pointer",
                    fontSize: "18px",
                  }}
                  onClick={() => {
                    downloadGetFileCSV();
                  }}
                >
                  Get Uploaded File
                </p>
              </ModalBody>
              <ModalFooter>
                <Button type="button" color="secondary" onClick={toggleFileUpload}>
                  Cancel
                </Button>{" "}
                <Button
                  type="button"
                  className="btn btn-primaryTwo"
                  onClick={toggleConfimCsvFile}
                >
                  Save
                </Button>
              </ModalFooter>
            </Form>
          </Modal>

    </>
  );
};

export default PurchaseOrdersByPurchaser;
